/**
 * Schweizerdeutsch UI strings.
 * Derived from Standard German with dialect adaptations for the Kjuup interface.
 */
export const GSW = {
  "preparing_zip": "ZIP wird vorbereitet…",
  "compressing": "Wird komprimiert…",
  "info_icon": "Sobald das Projekt als abgeschlossen markiert wird, chönd keini neuen Mitglieder mehr beitreten oder hinzugefügt wärde, und alle Chats wärde deaktiviert. Das Projekt sowie alle Chats und Daten bleiben im deaktivierten Zustand weiterhin zugänglich.",
  "mark_is_done": "Möchtest du das Projekt wirklich als abgeschlossen markieren? Sobald das Projekt als abgeschlossen markiert wird, chönd keini neuen Mitglieder mehr beitreten oder hinzugefügt wärde, und alle Chats wärde deaktiviert. Das Projekt sowie alle Chats und Daten bleiben im deaktivierten Zustand weiterhin zugänglich.",
  "mark_not_done": "Möchtest du das Projekt wirklich wieder öffnen? Sobald das Projekt wieder offen isch, chönd neuen Mitglieder beitreten oder hinzugefügt wärde, und alle Chats wärde reaktiviert.",
  "mark_as_completed": "Als abgeschlossen markieren",
  "room_completed": "Projekt abgeschlossen",
  "room_members": "Mitglieder des Projekts",
  "deactivated_rooms": "Deaktivierte Projekte",
  "deactivated_chats": "Deaktivierte Chats",
  "completed_rooms": "Abgeschlossene Projekte",
  "request_to_join_a_room": "Anfrage zum Beitritt beim Projekt",
  "wants_to_rejoin_room": "Username möchte dem Projekt Roomname wieder beitreten.",
  "invited_you_to_join_room": "Username möchte dich zum Projekt Roomname hinzufügen.",
  "update_text": "En neues Update isch verfügbar. Klicke auf Neustart um das Update zu installieren.",
  "restart": "Neustart",
  "update_availble": "Update verfügbar",
  "Loading": "Läd...",
  "logout": "Abmälde",
  "company_list": "Firmenliste",
  "followers": "Abonnenten",
  "followings": "Abonniert",
  "article": "Artikel",
  "articlen": "Artikeln",
  "invite_user_to_confirm_service": "Lade Teilnehmer*innen von Kjuup dazu en deine Leistungen zu bestätigen.",
  "companies": "Firmene",
  "one_to_one_chat": " Eins zu Eins Chat",
  "profile": "Profil",
  "company": "Firma",
  "company_selection": "Firmenauswahl",
  "home": "Zuhause",
  "contact": "Kontakt",
  "company_contact": "Kontakt",
  "add": "hinzufügen",
  "add_company": "Firma hinzufügen",
  "add_project": "Projekt hinzufügen",
  "capacities": "Kapazitäten",
  "work_area": "Arbeitsbereich",
  "of": "von",
  "company_services": "Firmenleistungen",
  "profile_company_services": "Firmenleistungen",
  "deselect_all": "Alle abwählen",
  "select_all": "Alle auswählen",
  "company_details_service": "Firmenleistungen",
  "website": "Webseite",
  "website_optional": "Webseite (optional)",
  "optional": "optional",
  "search_contacts": "Kontakte suchen",
  "add_or_join_a_company": "Firma hinzufügen oder beitreten",
  "follow": "Abonnieren",
  "mutual_contact": "gemeinsamer Kontakt",
  "mutual_contacts": "gemeinsame Kontakte",
  "following": "Abonniert",
  "like": "Gefällt mir",
  "company_contacts": "Firmenkontakt",
  "profile_company_contacts": "Firmenkontakt",
  "leave_the_company": "Die Firma verlassen",
  "news": "Mitteilungen",
  "earlier": "Früher",
  "action": "Aktion",
  "another_action": "Eine andere Aktion",
  "something_else": "etwas anderes",
  "search": "Suche",
  "search_rooms": "Projekte suchen",
  "search_articles": "Artikel suchen",
  "contacts": "Kontakte",
  "suggestions": "Vorschläge",
  "project_list": "Projektliste",
  "search_results": "Suchergebnisse",
  "add_or_join_project": "Projekt hinzufügen oder beitreten",
  "details": "Details",
  "map": "Karte",
  "or": "Oder",
  "name": "Name*",
  "street": "Strasse*",
  "house_number": "Hausnr.",
  "postal_code": "Postleitzahl",
  "city": "Stadt*",
  "opened_by": "Geöffnet von:",
  "project_No": "Projekt-nr: ",
  "building_type": "Gebäudetyp*",
  "building_types": "Gebäudetyp",
  "add_join": "Beitreten/Hinzufügen",
  "mandatory_fiels": "*Pflichtfeld",
  "invalid_fiels": "Pflichtfeld",
  "add_or_join_company": "Firma hinzufügen oder beitreten",
  "edit_company_details": "Firmeninformationen bearbeiten",
  "name_of_the_company": "Name",
  "branch_of_the_building_industry": "Branche der Bauindustrie",
  "corporate_form": "Gesellschaftsform",
  "position_within_company": "Position in der Firma",
  "request_confirmation": "Ausstehende Projekteinladungen",
  "company_e_mail": "Firmene E-Mail",
  "type_of_filter": "Typ zum Filtern ...",
  "setting": "Rahmen",
  "dashboard": "Dashboard",
  "settings": "Iistellige",
  "views": "ansichten",
  "times_seen": "mal gesehen",
  "in_search": "in der Suche",
  "reset_password": "Passwort zurücksetzen",
  "submit": "Bestätige",
  "password": "Passwort",
  "email": "E-Mail",
  "confirm_password": "Passwort bestätigen",
  "reset_email": "E-Mail zurücksetzen",
  "update": "Aktualisieren",
  "new_email": "Neue E-Mail",
  "kjuup_message": "Kjuup Nochricht",
  "my_position": "Meine Position:",
  "owner_company_admin": "Inhaber-Firmenadministrator :",
  "owner_company_admin_new": "Firmenadmin",
  "co_owner": "Mitinhaber/in",
  "managing_director": "Geschäftsführer/in",
  "associate": "Partner/in",
  "secretary": "Sekretär/in",
  "your_position_within_company": "Wähle bitte deine Position in der Firma",
  "employee": "Mitarbäiter/in",
  "project_manage": "Projektmanager/in",
  "delete_profile": "Profil löschen?",
  "auto_chat_translation": "Automatischi Chat-Übersetzig",
  "auto_translation_languages_title": "Spraache für automatischi Übersetzig",
  "auto_translation_languages_info": "Wähl, weli Spraache im Chat automatisch übersetzt wärde. Nochrichte, wo scho in diner Oberflächesprasch sind, wärde nöd übersetzt. Deaktiviere e Spraach, zum die Nochrichte im Original z laa.",
  "auto_translation_languages_save": "Übersetzigsspraache spychere",
  "auto_translation_languages_saved": "Iistellige für Übersetzigsspraache gspycheret",
  "auto_translation_languages_your_language": "dini Spraach — immer usgschlosse",
  "translate_room_group_names": "Chatgruppennäme übersetze",
  "translate_room_group_names_info": "Wenn aktiviert, wärde Chatgruppennäme automatisch in dini Oberflächesprasch übersetzt.",
  "email_summary_preview": "E-Mail-Zämefassig als Vorschau",
  "email_summary_preview_info": "Wenn aktiviert, zeigt d Nochrichtelischte e Zämefassig vo jeder E-Mail. Wenn deaktiviert, wird de erscht Satz vo de E-Mail azeigt.",
  "default_view_email": "Standardansicht: E-Mail",
  "default_view_email_info": "Wenn aktiviert, wird beim Öffnen der App standardmässig der E-Mail-Tab anstatt Nochrichte geöffnet.",
  "integrate_email_in_messages": "E-Mail & Nochrichte kombinieren",
  "integrate_email_in_messages_info": "Wenn aktiviert, wärde E-Mails aller verbundenen Konten zusammen mit Ihren Chat-Nochrichte nach Datum sortiert angezeigt.",
  "language": "Spraach",
  "english": "Änglisch",
  "german": "Schwiizerdütsch",
  "french": "Französisch",
  "italian": "Italienisch",
  "change_language": "Spraach ändere",
  "my_companies": "Meine Firmene",
  "employees": "Mitarbeitende",
  "invite_with_a": "Zu Kjuup einladen",
  "add_member": "Mitglied hinzufügen",
  "add_user": "Teilnehmer*in",
  "send_location": "Standort senden",
  "assign_admin_rights": "Adminrechte anpassen",
  "deactivate_company": "Firma deaktivieren",
  "no_user_found": "Keini Nutzer gefunden!",
  "remove_employees": "Mitarbäiter/in entfernen",
  "remove_members": "Mitgliider entfernen",
  "translation_on_building_projects": "Übersetzungsfunktion in Projekten",
  "reported_capacities": "Angebotene Leistungen",
  "see_more": "...mehr",
  "see_less": "...weniger",
  "up_to_50m_exact": "Bis zu 50m genau",
  "invite_with_link": "Zu Kjuup einladen",
  "share_link": "Einen Link teilen",
  "share_company_link": "Link teilen",
  "approve": "Bestätige!",
  "qr_code": "QR-Code",
  "copy_link": "Link kopieren",
  "cancel_link": "Link abbrechen",
  "who_has_confirmed_services": "Wer het deine Leistungen bestätigt?",
  "add_services": "Firmenleistungen hinzufügen",
  "save_text": "speichern",
  "share_on": "Teilen auf:",
  "link_copied": "Link kopiert!",
  "email_copied": "Email kopiert!",
  "personal_article": "Persönlicher Artikel",
  "comapny_article": "Firmenartikel",
  "characters_remaining": "verbleibende Zeichen",
  "artical_text": "Artikel verfassen...",
  "optional_information": "Optionale Information",
  "project": "Projekt",
  "projects": "Projekte...",
  "projectss": "Projekte",
  "abort": "Verwerfen",
  "preview": "Vorschau",
  "post": "Veröffentlichen",
  "remove": "Entfernen",
  "free_capacity": "Auftragsportal",
  "current_status_overview": "Übersicht über den aktuellen Status",
  "report_capacities": "Leistungen anbieten",
  "report_text": "Anbieten",
  "search_capacities": "Auftragnehmer finden",
  "find": "Finden",
  "add_project_user": "Projektbenutzer hinzufügen",
  "media": "Medien",
  "links": "Links",
  "docs": "Doks",
  "media_filter_photos": "Fotos",
  "media_filter_docs": "Dokumänt",
  "media_filter_source": "Quelle",
  "featured_products": "Ausgewählte Produkte...",
  "title": "Titel",
  "text": "Text",
  "select_profile_image": "Wähle en Profilbild",
  "feed_details": "Feed-Details",
  "add_employee": "Mitarbeitende hinzufügen",
  "my_projects": "Meine Projekte",
  "cancel": "Abbräche",
  "add_company_cancel": "Abbräche",
  "continue": "Wyter",
  "role_in_the_building_industry": "Branche",
  "close": "Schliesse",
  "close_modal": "Abbräche",
  "services": "Firmenleistungen",
  "request_to_join_a_company": "Anfrage zum Beitritt bei der Firma",
  "wants_to_join_the_company": "möchte der Firma",
  "als": "als",
  "join": "beitreten",
  "filter_by": "Filtern nach",
  "ok": "Ok",
  "latest": "Aktuell",
  "weekly_statistics": "Wöchentliche Statistik",
  "time": "Uhrzeit",
  "in_searches_in_past_week": " in Suchanfragen erschienen.",
  "is_following_you": "het sie abonniert.",
  "has_liked_your_article": "gefällt ihr Artikel.",
  "has_published_a_new_article": " het einen neuen Artikel veröffentlicht.",
  "as": "wie",
  "has_joined_the": "isch der Firma",
  "has_looked_at_your_profile": "het sich ihr Profil angesehen.",
  "you": "Sie",
  "have_joined_the": "haben sich dem Projekt",
  "building_project": " Bauprojekt.",
  "all_views": "Alle Ansichten",
  "you_have_been_found": "Sie wurden in der letzten Woche",
  "all_profile_views": "Alle Profilansichten",
  "mutual_company": "gemeinsame Firma",
  "mutual_companys": "gemeinsame Firmene",
  "you_have_appeared": " Du bist in der letzten Woche",
  "your_request_at_the_company": "Ihre Anfrage bei der Firma",
  "has_been_confirmed": "wurde bestätigt.",
  "improve_profile": "Profil verbessern",
  "choose_existing_contact_for_single_chat": "Wähle einen vorhandenen Kontakt für einen einzelnen Chat:",
  "in_order_to_add_new_contacts": "Um neue Kontakte hinzuzufügen, suche bitte auf der Profilseite nach neuen Kontakten.",
  "times_in_searches_in_the_last_week": "Mal in Suchanfragen gefunden. Aktualisiere dein Profil und füge weitere Details hinzu, um leichter gefunden zu wärde.",
  "appear_more_often_in_searches": "Erscheine häufiger in Suchanfragen",
  "times_you_have_appeared_in_searches": "Mal bist du in Suchanfragen erschienen",
  "select_with_which_company_you_want_to_connect_to_the_project": "Wähle die Firma, die du vertreten wirst. Dies wird anderen Teilnehmern angezeigt.",
  "select_with_which_company_you_want_to_connect_to_the_chat": "Wähle die Firma, die du vertreten wirst. Dies wird anderen Teilnehmern angezeigt.",
  "select_internal_section": "Bitte internen Bereich auswählen",
  "share_user": "Benutzer teilen",
  "contact_sender_message": "Teile diesen Link, um en/mehrere Nöd-Mitglied/er von Kjuup zu Kjuup einzuladen. Dieser Link cha von mehreren Personen zur Registrierung genutzt wärde.",
  "project_sender_message": "Teile diesen Link, um en Nöd-Mitglied von Kjuup zum Projekt project name einzuladen. Diesen Link chönd mehrere Personen zur Registrierung und zum Beitritt beim Projekt in Kjuup nutzen.",
  "company_sender_message": "Teile diesen Link, um en Nöd-Mitglied von Kjuup zur Firma company name einzuladen. Diesen Link chönd mehrere Personen zur Registrierung und zum Beitritt bei der Firma in Kjuup nutzen.",
  "contact_receivers_message": "Einladungslink, um Kjuup beizutreten. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren.",
  "iphone_recivers_message": "Falls du Kjuup über den Apple App Store installierst, musst du nach dem Download no diesen Link klicken, um dich registrieren zu chönd.",
  "iphone": "iPhone:",
  "project_receivers_message": "Einladungslink zum Projekt project name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und dem Projekt project name beizutreten.",
  "company_receivers_message": "Einladungslink zur Firma company name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und der Firma company name beizutreten.",
  "sign_in": "Aamälde",
  "enter_your_email_add": "E-Mail eingeben",
  "forgot_password": "Passwort vergessen",
  "dont_have_account": "Sie haben kei Konto ?",
  "register": "Registriere",
  "get_app": "Hol dir die App",
  "registration": "Registrierung",
  "dep_ing": "Dipl.-Ing.",
  "dr": "DR.",
  "dr_ing": "Dr.-Ing.",
  "dep_ing_arc": "Dipl.-Ing. Architekt",
  "prof": "Prof.",
  "first_name": "Vorname",
  "last_name": "Nachname",
  "have_an_account": "En Konto haben ?",
  "when_register_you_agree": "Indem du dich registrierst, stimmst du unseren",
  "term_of_use": "Nutzungsbedingungen",
  "in_our": "In unseren",
  "to": "bis",
  "data_policy": "Datenrichtlinien",
  "they_find_out": "erfährst du,",
  "we_provide_store_data": "wie wir Informationen erfassen, verarbeiten und speichern. ",
  "leaving_company_text": "Willst du die Firma wirklich verlassen? Wenn du die Firma verlässt, verlässt du au alle mit der Firma verbundenen Projekte und Chats. Du kannst diesen jederzeit erneut mit einer anderen Firma beitreten.",
  "delete_profile_text": "Willst du dein Profil wirklich löschen? Wenn du dein Profil löschst, wärde alle Verbindungen zu Firmene, Projekten und Chats entfernt. Du kannst jederzeit en neues Profil anlegen.",
  "confirm": "Bestätige",
  "reject": "Ablehnen",
  "requet_to_leave": "Firma verlassen",
  "choose": "Wählen Sie",
  "your_add_member": "Mitglied hinzufügen",
  "if_you": "wenn Sie",
  "can_not_find": "Ihren Kontakt hier nöd finden chönd.",
  "please_wait": "Bitte warten...",
  "imprint_gtc": "Impressum/AGB",
  "register_confirm_title": "Bitte bestätige dini E-Mail, bevor du di aamäldisch",
  "register_confirm_popup": "Bitte bestätige dini Kjuup-E-Mail-Adräss, bevor du di aamäldisch. Ohni die Bestätigung isch kei Login möglich. Mir händ der en Bestätigungslink gschickt. Falls du nüt findsch, lueg au im Spam-Ordner.",
  "resend_confirmation_email": "Bestätigungs-E-Mail no einisch schicke",
  "resend_confirmation_sent": "Falls die E-Mail-Adräss uf e Bestätigung wartet, händ mir en neue Link gschickt.",
  "PENDING_GROUP_USER": "erhält Nochrichte erst nachdem er/sie die Einladung zum Projekt bestätigt het. Sobald er/sie die Einladung bestätigt oder abgelehnt het wird dies hier angezeigt.",
  "PENDING": "Bestätigung der Einladung zum Projekt ausstehend",
  "denied_group_chat": " het die Einladung zum Projekt abgelehnt und den Chat verlassen.",
  "joined_group_chat": " isch dem Chat beigetreten.",
  "you_joined_group_chat": "Sie sind dem Chat beigetreten.",
  "Others": "Andere",
  "LEFT_GROUP": "het den Chat verlassen.",
  "YOU_LEFT_GROUP": "haben den Chat verlassen.",
  "days": "Tage",
  "day": "Tag",
  "hour": "Std.",
  "hide_project": "Projekt verbergen",
  "hide_project_popup_text": "Wenn du Projekte verbirgst, chönd diese in Kjuup nöd mehr gefunden wärde. Nur Mitglieder des Projekts chönd weitere Mitglieder einladen.",
  "branch": "Branche",
  "photo_video_media_lib": "Foto- und Videomediathek",
  "video_too_large": "Videos dürfen höchstens 200 MB gross sein.",
  "video_too_long": "Videos dürfen höchstens 15 Minuten lang sein.",
  "video_invalid": "Dieses Video konnte nöd gelesen wärde.",
  "video_one_at_a_time": "Bitte nur en Video auf einmal auswählen.",
  "video_or_images_only": "Bitte entweder Bilder oder en einzelnes Video auswählen.",
  "video_processing": "Video wird komprimiert…",
  "video_uploading": "Video wird hochgeladen…",
  "article_publish_preparing": "Wird vorbereitet…",
  "article_publish_compressing_video": "Video wird komprimiert…",
  "article_publish_preparing_media": "Fotos werden vorbereitet…",
  "article_publish_uploading": "Medien werden hochgeladen…",
  "article_publish_finishing": "Wird veröffentlicht…",
  "document": "Dokument",
  "location": "Standort",
  "location_meeting": "Standort",
  "all_member_of_project": "Alle Mitglieder des Projekts",
  "pending_request": "Ausstehende Projekteinladungen",
  "no_pending_request": "Keini ausstehenden Einladungen zu Projekten",
  "news_feed": "News-Feed",
  "user_info": "Gruppen Info",
  "leave_project": "Projekt verlassen",
  "media_link_docs": "Dateie",
  "search_chat": "Chat durchsuchen",
  "export_chat_group": "Chat-Daten des letzten Monats exportieren",
  "request_complete_chat_history": "Gesamten Chatverlauf anfordern",
  "leave_chat_group": "Chat verlassen",
  "add_user_project": "Teilnehmer*in hinzufügen",
  "me": "Ich",
  "max_open_one_to_one": "Derzeit chönd max. 2 Einzelchats parallel im oberen - und im unteren Bereich geöffnet wärde. Insgesamt chönd max. 4 Einzelchats geöffnet wärde.",
  "are_you_sure_you_want_leave_chat": "Willst du den Chat wirklich verlassen?",
  "create_group": "Gruppe erstellen",
  "adding_members": "Mitglieder hinzufügen...",
  "creating_the_chat": "Chat wird erstellt...",
  "finishing_setup": "Wird abgeschlossen...",
  "group_name": "Gruppenname",
  "by": "Von:",
  "mandetory": "*Pflichtfeld",
  "delteed": "het sein/ihr Profil gelöscht und den Chat verlassen.",
  "deleted_direct": "het sein/ihr Profil gelöscht und den Chat verlassen.",
  "unhidden_message": "Wenn du Projekte sichtbar machst, chönd diese in Kjuup von allen Kjuup Mitgliedern gefunden wärde.",
  "account_deleted": "Account wurde gelöscht.",
  "refuse_company": "Bist du sicher, dass du die Anfrage zum Beitritt bei der Firma ablehnen möchtest?",
  "follow_additional": "Weitere Teilnehmer*innen abonnieren",
  "f_add": "Weitere Teilnehmer*innen in Kjuup abonnieren, um mit ihnen per Direktnachricht zu kommunizieren.",
  "c_inv": "Firmeneinladung(en)",
  "invited_o_Company": "Sie wurden zur Firma",
  "refuse_companyX": "Bist du sicher, dass du die Einladung zur Firma ablehnen möchtest?",
  "a_Da": "Konto wurde deaktiviert.",
  "has_deactivated": "het sein/ihr Profil deaktiviert.",
  "reactive": "het sein/ihr Profil reaktiviert.",
  "email_username": "E-Mail/Benutzername*",
  "kjuup_note": "*Registrierung mit Benutzername nur für Teilnehmer/innen von Kjuup+ möglich.",
  "username": "Benutzername*",
  "sPinText": "Bitte erstelle deinen persönlichen 6-stelligen Pin. Der Pin wird benötigt, falls du dein Passwort vergisst und wird als Kontobestätigung vorausgesetzt.",
  "DeleteKjuupPlusText": "Willst du dein Profil wirklich löschen? Wenn du dein Profil löschst, wärde alle Verbindungen zu Firmene, Projekten und Chats entfernt.\n\nDu kannst dein Profil innerhalb von 48 Stunden reaktivieren, indem du dich mit deinem Benutzernamen, Passwort und Pin bei Kjuup anmeldest. ",
  "reactive_text": "Dein Konto wurde gelöscht. Bitte klicke auf Reaktivieren um dein Konto zu reaktivieren.",
  "rac": "Reaktivieren",
  "ac_ss": "Konto wurde erfolgreich reaktiviert.",
  "not_valid_pin": "Pin ungültig",
  "only_for_kjuup": "*Password zurücksetzen via Benutzername und Pin nur für Teilnehmer/innen von Kjuup+ möglich.",
  "resetPIN": "PIN zurücksetzen",
  "enter_current_pin": "Bitte gib deinen aktuellen PIN en",
  "enter_new": "Bitte neuen PIN eingeben",
  "pin_to_confirm": "PIN eingeben, um zu bestätigen.",
  "change_username": "Benutzernamen zurücksetzen",
  "pp_not_match": "Passwort und Passwortbestätigung stimmen nöd überein",
  "reactive_itself": "Du hast dein Profil reaktiviert.",
  "has_deactivated_itself": "Du hast dein Profil deaktiviert.",
  "more_than_two": "Derzeit chönd Direktnachrichten mit max. 2 Personen parallel ausgeführt wärde.",
  "Chats": "Direktnachrichten",
  "only_in_mobileL": "Native Videos chönd derzeit nur via mobiler App hochgeladen und geposted wärde. Verwende jederzeit gerne Video-Links von Youtube oder Vimeo.",
  "register_pin_text": "Wähle bitte deinen persönlichen 6-stelligen PIN. Dieser wird beim Zurücksetzen einzelner Kontodetails benötigt.",
  "internal_project": "Intern",
  "external_projects": "Extern",
  "in_deacticted": "Interner Bereich isch deaktiviert.",
  "create_article": "Artikel erstellen",
  "new_article_selection": "Artikel für externen News-Feed erstellen",
  "new_article_selection_internal": "Firmeninternen Artikel erstellen",
  "active_trans_title": "Automatische Übersetzung aktivieren?",
  "active_trans": "Wenn aktiviert, wärde alle eingehenden Chat-Nochrichte in deine ausgewählte App-Spraach übersetzt.",
  "disable_trans": "Willst du die automatische Übersetzung deaktivieren?",
  "allow_access_chat": "Kompletten Chatverlauf anzeigen",
  "toggle_chat_history_on": "Willst du wirklich, dass der/die Teilnehmer/in den kompletten Chatverlauf einsehen cha?",
  "toggle_chat_history_off": "Willst du wirklich, dass der/die Teilnehmer/in den Chatverlauf erst ab dem Zeitpunkt des Beitritts einsehen cha?",
  "check_selected_settings": "Bitte die Iistellige zum Chatverlauf bei allen ausgewählten Teilnehmer/innen kontrollieren!",
  "chat_from_start_have": "Sie sind dem Chat beigetreten. Der Chatverlauf wurde mit Ihnen geteilt.",
  "chat_from_start_has": "isch dem Chat beigetreten. Der Chatverlauf wurde mit ihm/ihr geteilt.",
  "Address": "Address",
  "read_by": "Gelesen von",
  "deliver_to": "Zugestellt an",
  "remaining": "ausstehend",
  "message_info": "Nachrichteninfo",
  "request_to_join_only": "Teilnahme anfragen",
  "unfollow": "Entfernen",
  "company_username": "Benutzername",
  "month": [
    "Jan",
    "Feb",
    "März",
    "Apr",
    "Mai",
    "Juni",
    "Juli",
    "Aug",
    "Sept",
    "Okt",
    "Nov",
    "Dez"
  ],
  "remove_my_admin_right": "Meine Adminrechte entfernen",
  "makeEmp": "Willst du dem/der Teilnehmer*in wirklich Adminrechte bei der Firma entziehen?",
  "makeAdmin": "Willst du dem/der Teilnehmer*in wirklich Adminrechte für die Firma zuweisen?",
  "remove_my_self": "Willst du dir wirklich Adminrechte bei der Firma entziehen?",
  "remove_member": "Mitarbäiter/in entfernen",
  "remove_following_confirm": "Willst du {name} wirklich us der Liste Abonniert entfernen?",
  "remove_follower_confirm": "Willst du {name} wirklich us der Liste der Abonnenten entfernen? Wenn du ihn/sie entfernst, wird er/sie nöd darüber informiert.",
  "do_you_really_want_to_remove": "Willst du den/die Mitarbäiter/in username wirklich us der Firma entfernen?",
  "dep_loc": "Abteilung/Standort/Team",
  "notify_employees_via_dm": "Mitarbäiter per Direktnachricht informieren",
  "notify_employees_via_dm_hint": "Sendet beim Veröffentlichen eine Chat-Nochricht von deinem Konto an Mitarbäiter der ausgewählten Abteilungen, Standorte oder Teams.",
  "notify_employees_via_dm_hint_edit": "Sendet eine Chat-Nochricht von deinem Konto an Mitarbäiter der ausgewählten Abteilungen, Standorte oder Teams über die Änderungen.",
  "depAdmin": "Abteilungsadmin",
  "add_remove_admin": "Firmenadmin hinzufügen/entfernen",
  "add_remove_dep_admin": "Abteilungsadmin hinzufügen/entfernen",
  "remove_employees_dept": "Mitarbäiter/in entfernen us",
  "want_to_join_dep": "Username möchte Abteilung/Standort/Team depname von der Firma companyname beitreten.",
  "you_invited": "Sie wurden zu Abteilung/Standort/Team depname bei der Firma companyname eingeladen.",
  "dep_remove": "Willst du dem/der Teilnehmer*in wirklich Adminrechte für die Abteilung / Standort entziehen?",
  "add_dep": "Willst du dem/der Teilnehmer*in wirklich Adminrechte für die Abteilung / Standort zuweisen?",
  "my_self_dep_remove": "Willst du dir wirklich die Rechte als Abteilungsadmin entziehen?",
  "company_sender_message_dep": "Einladungslink zu depname in der Firma company name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und der Firma company name beizutreten.",
  "invite_all": "Alle Mitarbäiter/innen der Firma einladen",
  "invite_all_members": "Alle Teilnehmer/innen einladen",
  "mems": "Alle weiteren Teilnehmer/innen",
  "member": "Mitglied",
  "admin": "Admin",
  "remove_project_admin": "Willst du das Mitglied wirklich us dem Projekt entfernen?",
  "remove_my_self_project": "Willst du dir wirklich Adminrechte entziehen?",
  "remove_member_admin_right": "Willst du dem Admin wirklich Adminrechte entziehen?",
  "add_member_admin_right": "Willst du dem Mitglied wirklich Adminrechte zuweisen?",
  "add_remove_Poss": "Admin hinzufügen/entfernen",
  "forward": "Weiterleiten",
  "forward_to": "Weiterleiten an...",
  "edit": "Editieren",
  "only_kjuup_plus_can": "Nur Kjuup+ Firmene chönd Artikel posten.",
  "add_images": "Bilder hinzufügen",
  "add_images_or_pdf": "Bilder, Videos oder PDFs hinzufügen",
  "drop_files_here": "Dateien hier ablegen",
  "drag_and_drop_hint_pdf": "oder Bilder/Videos/PDFs hier hineinziehen",
  "unsupported_file_type": "Nöd unterstützter Dateityp. Nur Bilder, Videos und PDFs sind erlaubt.",
  "max_file_size_exceeded_25mb": "Max. Grösse von 25MB überschritten. Bitte eine kleinere Datei wählen.",
  "Activity": "Aktivität",
  "latest_messages": "Letzte Nochrichte",
  "hours": "Std.",
  "minute": "Minuten",
  "seconds": "Sekunde",
  "yesterday": "Gestern",
  "last_week": "Letzte Woche",
  "this_week": "Diese Woche",
  "next_week": "Nächste Woche",
  "Last_month": "Letzter Monat",
  "this_month": "Diesen Monat",
  "All": "Alle",
  "register_plus": "Registrierung Plus",
  "select_files": "Medien auswählen",
  "monthsFullName": [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ],
  "company_deploc_receivers_message": "Einladungslink zu department in der Firma company name in Kjuup. Bitte klicke auf den Link, um dich bei Kjuup zu registrieren und der Firma company name beizutreten.",
  "no_news": "Keini Mitteilungen vorhanden",
  "reminder": "Erinnerungen",
  "np_reminder": "Keini Aufgaben",
  "move_to_reminder": "Als Aufgabe speichern",
  "remove_reminder": "Willst du die Nochricht wirklich von der Liste deiner Aufgaben entfernen?",
  "remove_all_reminder": "Alle Aufgaben entfernen",
  "remove_all_confirm": "Willst du wirklich alle Nochrichte von der Liste deiner Aufgaben entfernen?",
  "remove_from_reminder": "Von Aufgaben entfernen",
  "prevent_email": "Eine E-Mail cha nöd als Benutzername angegeben wärde.",
  "allow_noti": "Bitte erlaube Benachrichtigungen.",
  "join_cap": "Beitreten",
  "pass_minimum": "**Passwort muess 12 Zeichen inkl. Klein-, Grossbuchstabe, Nummer und Sonderzeichen beinhalten.",
  "pass_error": "Bitte Passwortanforderungen überprüfen",
  "frequent": "Zuletzt verwendet",
  "people": "Smileys und Emotionen",
  "people_that_like_article": "Personen, denen dein Artikel gefällt.",
  "people_who_like_article": "Personen, denen der Artikel gefällt.",
  "show_draft": "Entwurf anzeigen...",
  "draft_prefix": "Entwurf:",
  "message_delete": "Diese Nochricht wurde gelöscht.",
  "message_edited": "bearbeitet",
  "edit_message": "Nochricht bearbeite",
  "edit_window_expired": "Nochrichte chönd nur innerhaub vo 10 Minute nach em Sende bearbeitet wärde.",
  "message_edit_save": "Spichere",
  "copy": "Kopiere",
  "bookmark": "Merke",
  "add_reaction": "Reaktion hinzuefüege",
  "delete_message": "Nochricht lösche",
  "more_options": "Meh Optione",
  "reacted_with": "reagierte mit",
  "delete_message_confirm": "Möchtest du diese Nochricht wirklich löschen?",
  "link_invite": "Per Link einladen",
  "ll_nkk": "Zu Kjuup einladen",
  "selected": "Ausgewählt",
  "is_active": "Aktiv",
  "inactive": "Inaktiv",
  "last_online": "zletscht online {{when}}",
  "remove_user_l": "Entfernen",
  "assign_group_admin_rights": "Adminrechte zuweisen",
  "remove_group_admin_rights": "Adminrechte entziehen",
  "link_expire": "Jeder generierte Link isch 72 Stunden gültig.",
  "company_language": "Firmensprache",
  "company_language_info": "Die Sprachauswahl wird für alle E-Mail Bestätigungen, die die Firma betreffen, verwendet.",
  "article_translation_target_languages_title": "Sprachen für Artikelübersetzung",
  "article_translation_target_languages_info": "Wähle us, in welche Kjuup-Oberflächensprachen die Artikel dieser Firma übersetzt wärde sollen. Standardmässig gelten dieselben Sprachen wie bei externen Artikeln. Firmenadmins chönd die Liste anpassen.",
  "article_translation_target_languages_save": "Spychere",
  "article_translation_languages_saved": "Sprachen für Artikelübersetzung gespeichert",
  "article_original_language": "Originalsprache",
  "article_original_language_info": "Die Spraach, in der der Artikel verfasst isch. Der Artikel wird nöd in diese Spraach übersetzt.",
  "s_image": "Bild",
  "m_image": "Bilder",
  "removeMsg": "Tippen zum Entfernen",
  "block": "Blockieren",
  "unblock": "Entblocken",
  "blocks": "Willst du den/die Benutzer*in wirklich blockieren?",
  "unblocks": "Willst du den/die Benutzer*in wirklich entblocken?",
  "bolcked_click_un_block": "Du hast den Kontakt blockiert. Klicke hier um ihn zu entblocken.",
  "you_blocked_contact": "Sie haben den Kontakt geblockt.",
  "you_unblocked_contact": "Sie haben den Kontakt entblockt.",
  "you_have_unblocked": "Sie haben den Kontakt entblockt.",
  "you_have_blocked": "Sie haben den Kontakt blockiert.",
  "unblock_to_send": "Entblocke den/die Benutzer*in um Nochrichte zu senden.",
  "back": "Zrugg",
  "pilot_text": "Spezialisierte KI für Bau-Themen",
  "support_text": "Chat mit Kjuup Support",
  "todo_notification_label": "Zähler und Push-Benachrichtigungen für zugewiesene Aufgaben",
  "todo_notification_info": "Du wirst benachrichtigt, sobald dir e neui Aufgabe zugewiesen wird.",
  "daily_briefing_label": "Tagesbericht",
  "daily_briefing_info": "Erstellt täglich en Tagesbericht für alli Projekt in de Nachrichte zur Zyt, wo du unte feschtlegsch, wenn es E-Mail-Konto verbunde isch und mindestens eis Projekt Aktivität gha het. Es wird nöd per E-Mail gschickt.",
  "daily_briefing_notification_label": "Zähler Benachrichtigungen für Tagesbericht",
  "daily_briefing_notification_info": "Zeigt d Anzahl ungläsener Tagesberichte am Projekt-Symbol, am betreffende Projekt und am Tagesbericht-Tab.",
  "daily_briefing_hour_label": "Zyt für de Tagesbericht",
  "daily_briefing_hour_info": "De Tagesbericht wird zu dere Zyt (Europe/Berlin) erstellt. Isch d Zyt hüt scho verbi, wirder gli erzeugt.",
  "daily_briefing_hour_saved": "Zyt für de Tagesbericht aktualisiert",
  "daily_briefing_model_label": "KI-Modell für de Tagesbericht",
  "daily_briefing_model_internal": "Intern (Kjuup-KI)",
  "daily_briefing_model_external": "Extern (Mistral)",
  "daily_briefing_model_internal_info": "Lauft uf Kjuup-eigene Server. Inhalt verlönd Kjuup nöd.",
  "daily_briefing_model_external_info": "Neuschts passends Modell vo Mistral AI (Frankrych). Inhalt us Ihre Projekt wird zur Erstellig a Mistral übermittlet.",
  "daily_briefing_model_info": "Gilt ab em nächschte Tagesbericht.",
  "daily_briefing_model_saved": "KI-Modell für de Tagesbericht aktualisiert",
  "room_daily_briefing_label": "Individuelle Projekt-Tagesbericht",
  "room_daily_briefing_info": "Wenn aktiviert, wird alli 24 Stund zur Zyt us de persönliche Istellige en Tagesbericht für das Projekt erstellt — aber nur, wenn i dere Zyt Aktivität gha het.",
  "startup_screen_label": "Startbildschirm",
  "startup_screen_info": "Wähle, welcher Bildschirm beim Start von Kjuup geöffnet wird.",
  "startup_screen_feed": "Home",
  "startup_screen_messages": "Nochrichte",
  "startup_screen_saved": "Startbildschirm aktualisiert",
  "email_on": "E-Mail Benachrichtigung Chats",
  "email_on_grp": "E-Mail Benachrichtigung",
  "article_email_on": "E-Mail Benachrichtigung Artikel",
  "article_email_info": "Wenn du E-Mail-Benachrichtigungen für interne Artikel aktivierst, erhältst du eine E-Mail, sobald en neuer interner Artikel in deiner Firma und deiner Abteilung veröffentlicht wird.",
  "info_email_room": "Aktiviere oder deaktiviere E-Mail Benachrichtigungen für dieses Projekt. Diese Option isch nur verfügbar, wenn \"E-Mail Benachrichtigung Chats\" in den persönlichen Iistellige aktiviert isch. ",
  "info_val": "Du erhältst eine E-Mail, wenn eine neue Chat-Nochricht nöd innerhalb kurzer Zeit gelesen wird. Einzelne Projekte oder Chats kannst du in deren Iistellige bzw. in der Gruppeninfo deaktivieren.",
  "email_groups": "Aktiviere oder deaktiviere E-Mail Benachrichtigungen für diesen Chat. Diese Option isch nur verfügbar, wenn \"E-Mail Benachrichtigung Chats\" in den persönlichen Iistellige und in den Projekt-Iistellige aktiviert isch.",
  "add_update_email": "E-Mail hinzufügen/aktualisieren",
  "add_update_email_for_notifications": "E-Mail für E-Mail Benachrichtigungen hinzufügen/aktualisieren",
  "text_to_verifiy": "Die Option \"E-Mail-Benachrichtigungen Chats\" cha nur aktiviert wärde, wenn du eine bestätigte E-Mail hinterlegt hast.",
  "stored_email": "Hinterlegte E-Mail: ",
  "verify_email": "Bestätigung ausstehend!",
  "verified": "Verifiziert",
  "join_call": "Beitreten",
  "call_is_started": "Anruf gestartet",
  "start_chat": "Direkt-Chat starten?",
  "start_chat_button": "Neue Nochricht",
  "start_direct_message": "Direktnachricht starten?",
  "project_rooms": "Projekte",
  "download_selected": "Abelade",
  "download_to_folder": "I Ordner abelade",
  "download_as_zip": "Als ZIP abelade",
  "media_download_progress": "Lade {current} vo {total} ab",
  "media_downloaded_on": "Bilder abelade am {datetime}",
  "docs_downloaded_on": "Dokument abelade am {datetime}",
  "media_auto_download": "Automatische Medie-Download",
  "media_auto_download_hint": "Neui Bilder und Dokument wärde am 20:00 gspeicheret",
  "media_auto_download_info": "Wähl eimal en Ordner. Neui Bilder und Dokument us däm Chat oder Projekt wärde dört jede Tag am 20:00 automatisch gspeicheret. Isch Kjuup denn zue, lauft de Download bim nächschte Öffne vo de App.",
  "media_auto_download_unsupported": "D Ordneruswahl brucht Chrome oder Edge",
  "media_auto_download_continue": "Ordnerzuegriff erlaube zum wiiterfahre",
  "media_export_server": "Medie-Exportserver",
  "media_export_server_info": "Verbind en WebDAV- oder SFTP-Server. Jede Chat und jedes Projekt cha denn jede Oobe am 20:00 neui Medie i en eigene Ordner exportiere.",
  "media_export_protocol": "Protokoll",
  "media_export_host": "Host",
  "media_export_port": "Port",
  "media_export_username": "Benutzername",
  "media_export_password": "Passwort",
  "media_export_base_path": "Basispfad (optional)",
  "media_export_test": "Verbindig teste",
  "media_export_test_ok": "Verbindig erfolgriich",
  "media_export_test_fail": "Verbindig fehlgschlage",
  "media_export_saved": "Verbindig gspeicheret",
  "media_export_disconnect": "Trenne",
  "media_export_disconnect_confirm": "Dä Dateiserver trenne?",
  "media_export_folder": "Nächtliche Medie-Export",
  "media_export_folder_placeholder": "/Projekte/Alpha",
  "media_export_nightly_hint": "Neui Bilder, Videos und Dokument wärde am 20:00 ufgalade",
  "media_export_nightly_info": "Neui Bilder, Videos und Dokument wärde jede Oobe am 20:00 i de Ordnerpfad uf em Firmeserver ufgalade. D App muess nöd offe si.",
  "media_export_admin_required": "En Dateiserver muess im Admin Panel verbunde si.",
  "media_export_readonly": "Wird znacht nach {path} exportiert",
  "media_export_last_error": "Letschte Export fehlgschlage",
  "change": "Ändere",
  "add_employee_confirm": "Möchtest du diesen Benutzer wirklich zur Firma hinzufügen?",
  "invalid_deeplink": "Ungültiger Deeplink. Erforderliche Parameter fehlen.",
  "deeplink_error": "Deeplink konnte nöd verarbeitet wärde. Bitte versuche es später erneut.",
  "reply": "Antworten",
  "reply_enter": "Antwort eingeben…",
  "reply_sent_successfully": "Antwort erfolgreich gesendet",
  "reply_failed": "Antwort konnte nöd gesendet wärde",
  "reply_failed_generic": "Antwort konnte nöd gesendet wärde. Bitte versuche es erneut.",
  "replying_to_message": "Antwort auf Nochricht",
  "cancel_reply": "Antwort abbrechen",
  "voice_message": "Sprachnachricht",
  "send": "Antworten",
  "type_your_reply": "Antwort eingeben…",
  "suggested_replies": "Vorgeschlagene Antworten",
  "suggestions_error": "Vorschläge konnten nöd geladen wärde",
  "positive_suggestion_placeholder": "Positive",
  "neutral_suggestion_placeholder": "Neutral",
  "negative_suggestion_placeholder": "Negative",
  "lazy_media_image": "Bild — Klicken zum Laden",
  "lazy_media_audio": "Sprachnachricht — Klicken zum Laden",
  "lazy_media_doc": "Dokument — Klicken zum Laden",
  "lazy_media_video": "Video — Klicken zum Laden",
  "suggestion_loading_message": "Nur no en kurzer Moment. Dein Text wird individuell für dich vorbereitet.",
  "loading_chat_message": "Lade Chat...",
  "create_todo": "Aufgabe erstellen",
  "create_todo_confirmation": "Möchtest du us dieser Nochricht e Aufgabe erstellen?",
  "select_project_required": "Bitte wähle en Projekt/eine Gruppe",
  "only_assigned_can_change_status": "Nur zugewiesene Benutzer chönd den Status ändern",
  "todo_summary": "Zusammenfassung",
  "todo_summary_placeholder": "Zusammenfassung vo de Aufgabe iigäh...",
  "todo_date": "Datum",
  "todo_time": "Uhrzeit",
  "deadline": "Frist",
  "todo_date_hint": "Leer lassen, um das ursprüngliche Nachrichtendatum zu verwenden",
  "todo_created_success": "Aufgabe erfolgreich erstellt",
  "extracting_message": "Nochricht wird extrahiert...",
  "creating_todo": "Aufgabe wird erstellt...",
  "bookmark_todo_creating": "Vorgmerkti Ufgab wird erstellt...",
  "navigating_to_todo": "Weiterleitung zu de Aufgaben...",
  "todo_creation_failed": "Aufgabe konnte nöd erstellt wärde",
  "todo_created_from_message": "Aufgabe us dieser Nochricht erstellt",
  "create": "Erstellen",
  "image": "Bild",
  "images": "Bilder",
  "remove_all_images": "Alle Bilder entfernen",
  "remove_image": "Bild entfernen",
  "remove_document": "Dokument entfernen",
  "remove_recording": "Aufnahme entfernen",
  "play_recording": "Aufnahme abspielen",
  "upload_image": "Bild hochladen",
  "upload_document": "Dokument hochladen",
  "record_audio": "Audio aufnehmen",
  "stop_recording": "Aufnahme stoppen",
  "stop_recording_text": "Aufnahme stoppen",
  "please_remove_current_attachment": "Bitte entferne den aktuellen Anhang, um",
  "please_upload_image_file": "Bitte lade eine gültige Bilddatei hoch",
  "please_upload_valid_document": "Bitte lade eine gültige Dokumentdatei hoch",
  "searching_messages": "Nochrichte wärde gesucht...",
  "loading_more": "Weitere wärde geladen...",
  "loading_more_users": "Weitere Benutzer wärde geladen...",
  "load_more_users": "Weitere Benutzer laden",
  "no_more_users_to_load": "Keini weiteren Benutzer zu laden",
  "no_messages_found": "Keini Nochrichte gefunden",
  "try_different_keyword": "Versuche en anderes Schlüsselwort oder überprüfe die Schreibweise.",
  "search_messages": "Nochrichte, Chats, Aufgaben, Projekte und Benutzer suchen..",
  "search_messages_with_email": "Nochrichte, E-Mails, Chats, Aufgaben, Projekte und Benutzer suchen..",
  "search_groups": "Gruppen",
  "search_chat_groups": "Chats",
  "search_project_room": "Projekt",
  "search_messages_tab": "Nochrichte",
  "search_result_kjuup_chat": "Nochrichte Kjuup Chat",
  "search_users_tab": "Benutzer",
  "search_documents_tab": "Dokumente",
  "company_documents": "Firmendokumente",
  "company_documents_empty": "Keini Dokumente vorhanden.",
  "no_media_available": "Keini Dateie",
  "no_documents_available": "Keini Dokumente",
  "searching_groups": "Gruppen wärde gesucht...",
  "searching_rooms": "Projekte wärde gesucht...",
  "searching_users": "Benutzer wärde gesucht...",
  "no_groups_found": "Keini Gruppen gefunden",
  "no_rooms_found": "Keini Projekte gefunden",
  "no_users_found": "Keini Benutzer gefunden",
  "search_emails_tab": "E-Mail",
  "searching_emails": "E-Mails wärde gesucht...",
  "no_emails_found": "Keini E-Mails gefunden",
  "search_email_addresses_tab": "E-Mail Adressen",
  "search_email_content_tab": "E-Mail Inhalt",
  "searching_email_content": "E-Mail-Inhalt wird gesucht...",
  "no_email_content_found": "Kei E-Mail-Inhalt gefunden",
  "search_email_attachments_tab": "E-Mail Anhänge",
  "searching_email_attachments": "Anhänge wärde gesucht...",
  "no_email_attachments_found": "Keini Anhang-Treffer gefunden",
  "email_attachments_label": "Anhänge",
  "searching_email_addresses": "Adressen wärde gesucht...",
  "no_email_addresses_found": "Keini Adress-Treffer gefunden",
  "search_email_filter_all": "Alle",
  "search_email_filter_content": "Inhalt",
  "search_email_filter_addresses": "Adressen",
  "search_email_filter_attachments": "Anhänge",
  "search_email_filter_has_attachments": "Mit Anhang",
  "search_email_filter_unread": "Ungelesen",
  "search_email_combo_placeholder": "In E-Mails vo (optional)…",
  "search_email_combo_content_placeholder": "In dene E-Mails sueche…",
  "search_email_combo_hint": "Suechi in E-Mails vo",
  "search_email_combo_containing": "mit Inhalt",
  "search_describe": "Beschriib, wonach du suechsch…",
  "search_describe_examples_with_email": "z. B. E-Mails vo ml@bl2020.com mit Passwort · Nachrichten vo Martin über Rechnung · Benutzer Martin Langen",
  "search_intent_understood": "Suechi",
  "search_intent_emails": "E-Mails",
  "search_intent_messages": "Nochrichte",
  "search_intent_user": "Benutzer",
  "search_submit": "Sueche",
  "email_subject_label": "Betreff",
  "email_body_label": "Text",
  "email_address_received": "Empfangen",
  "email_address_sent": "Gesendet",
  "search_todos_tab": "Aufgaben",
  "no_todos_found": "Keini Aufgaben gfunde",
  "todo": "Aufgabe",
  "np_todo": "Keini Aufgaben",
  "move_to_todo": "Als Aufgabe speichern",
  "remove_todo": "Willst du die Aufgabe wirklich entfernen?",
  "remove_all_todo": "Alle Aufgaben entfernen",
  "remove_all_todo_confirm": "Willst du wirklich alle Aufgaben entfernen?",
  "add_to_todo": "Zu de Ufgabe hinzuefüege",
  "remove_from_todo": "Von Aufgaben entfernen",
  "read_more": "Mehr lesen",
  "show_less": "Weniger anzeigen",
  "show_more": "Mehr anzeigen",
  "audio": "Audio",
  "video": "Video",
  "notification_schedule": "Benachrichtigungsplan",
  "notification_schedule_desc": "Sie erhalten Push- und E-Mail-Benachrichtigungen nur in den von Ihnen gewählten Stunden. Ausserhalb dieser Zeiten wärde sie pausiert.",
  "company_notification_schedule_desc": "Lege die Benachrichtigungszeiten für alle Firmenmitglieder fest. Dadurch wärde die persönlichen Benachrichtigungseinstellungen aller Mitglieder überschrieben.",
  "learn_more": "Mehr erfahren",
  "allow_notifications": "Benachrichtigungen erlauben:",
  "every_day": "Jeden Tag",
  "weekdays": "Wochentage (Montag bis Freitag)",
  "custom": "Benutzerdefiniert",
  "monday": "Montag",
  "tuesday": "Dienstag",
  "wednesday": "Mittwoch",
  "thursday": "Donnerstag",
  "friday": "Freitag",
  "saturday": "Samstag",
  "sunday": "Sonntag",
  "notification_settings": "Benachrichtigungen",
  "notification_settings_saved": "Benachrichtigungseinstellungen erfolgreich gespeichert",
  "notification_settings_error": "Fehler beim Spychere der Benachrichtigungseinstellungen",
  "unavailability_note": "Abwesenheitsnotiz",
  "unavailability_description": "Legen Sie eine Abwesenheitsnotiz fest. Solange aktiv, wird die Notiz in allen Ihren Chats angezeigt und Benachrichtigungen wärde pausiert.",
  "unavailability_start_date": "Startdatum",
  "unavailability_end_date": "Enddatum",
  "unavailability_message": "Nochricht",
  "unavailability_message_hint": "Verwenden Sie {endDate} als Platzhalter für Ihr Rückkehrdatum.",
  "unavailability_replacement": "Vertretung",
  "unavailability_replacement_placeholder": "Benutzer-ID für dringende Anfragen eingeben",
  "unavailability_replacement_current": "Aktuelle Vertretung",
  "unavailability_replacement_hint": "Falls gesetzt, wird en Link angezeigt, um diese Person bei dringenden Angelegenheiten zu kontaktieren.",
  "unavailability_replacement_none": "Keini Vertretung (optional)",
  "unavailability_contact_urgent": "Für dringende Anfragen kontaktieren Sie",
  "unavailability_default_message": "Ich bin derzeit nöd im Büro und habe keinen Zugriff auf Kjuup. Ab dem {endDate} bin ich wieder erreichbar und melde mich dann bei Ihnen.",
  "unavailability_save": "Spychere",
  "unavailability_deactivate": "Deaktivieren",
  "unavailability_active_until": "Aktiv bis",
  "unavailability_saved": "Abwesenheitsnotiz gespeichert",
  "unavailability_save_error": "Fehler beim Spychere der Abwesenheitsnotiz",
  "unavailability_deactivated": "Abwesenheitsnotiz deaktiviert",
  "unavailability_end_date_required": "Enddatum isch erforderlich",
  "start_time_before_end_time": "Startzeit muess vor Endzeit liegen",
  "loading": "Laden",
  "disabled": "Deaktiviert",
  "enable": "Aktivieren",
  "disable": "Deaktivieren",
  "forwarded": "Weitergeleitet",
  "message_forwarded": "Nochricht weitergeleitet!",
  "schedule_article_post": "Termin für Beitrag festlegen",
  "date": "Datum",
  "scheduled_for_publication": "Zur Veröffentlichung geplant",
  "scheduled_and_drafts": "Geplante Artikel und Entwürfe",
  "article_scheduled": "Geplant",
  "article_draft": "Entwurf",
  "article_drafts": "Entwürfe",
  "no_scheduled_or_drafts": "Keini geplanten Artikel oder Entwürfe",
  "no_scheduled_articles": "Keini geplanten Artikel",
  "no_draft_articles": "Keini Entwürfe",
  "save_as_draft": "Als Entwurf speichern",
  "article_will_be_published_on": "Artikel wird veröffentlicht am:",
  "reset_selection": "Auswahl zurücksetzen",
  "error_loading_members": "Fehler beim Laden der Mitglieder",
  "please_fill_all_fields": "Bitte fülle alle Felder us",
  "invalid_email": "Ungültige E-Mail-Adresse",
  "member_added_successfully": "Mitglied erfolgreich hinzugefügt",
  "error_onboarding_user": "Fehler beim Hinzufügen des Benutzers",
  "error_creating_chat": "Fehler beim Erstellen des Chats",
  "error_creating_group": "Fehler beim Erstellen der Gruppe",
  "new_group": "Neue Gruppe",
  "please_select_or_enter_group_name": "Bitte wähle eine Gruppe us oder gib einen Gruppennamen en",
  "please_select_or_enter_room_name": "Bitte wähle ein Projekt us oder gib einen Projektnamen en",
  "error_creating_room": "Fehler beim Erstellen des Projekts",
  "error_opening_chat": "Fehler beim Öffnen des Chats",
  "privacy_modal_text": "Wähle privat nur, wenn er Chat keini relevanten fachlichen Inhalte für Projektleiter enthält.",
  "not_private": "Nöd privat",
  "private": "Privat",
  "error_loading_groups": "Fehler beim Laden der Gruppen",
  "automatic_chat_export": "Automatischer Chat Export",
  "automatic_chat_export_info": "Nach Aktivierung erhältst du die Chat-Historie monatlich automatisch an die angegebene E-Mail-Adresse.",
  "automatic_chat_export_no_email": "Um den automatischen Chat-Export zu aktivieren, musst du zuerst eine E-Mail-Adresse hinterlegen. Du kannst deine E-Mail-Adresse in den persönlichen Iistellige ergänzen.",
  "enter_email": "E-Mail eingeben",
  "export_to_email": "Der Export erfolgt an folgende E-Mail.",
  "matching_existing_chats": "Passende bestehende Chats",
  "subject": "Betreff",
  "add_subject": "Betreff hinzufügen",
  "chat_subject": "Chat Betreff:",
  "set_project_room": "Projekt festlegen",
  "matching_existing_project_rooms": "Passende bestehende Projekte",
  "name_project_room": "Projektname",
  "professional_or_private": "Beruflich oder privat",
  "professional": "Beruflich",
  "privacy_modal_text_updated": "Wähle \"Privat\" nur, wenn der Chat keini relevanten fachlichen Inhalte für Projektleiter enthält. Private Chats sind für Projektleiter nöd einsehbar.",
  "create_internal_chat": "Externer - oder interner Chat?",
  "internal_chat_description": "Zu internen Chats chönd ausschliesslich eigene Mitarbeitende hinzugefügt wärde.",
  "yes": "Ja",
  "no": "Nein",
  "chat_is_being_created": "Chat wird erstellt...",
  "discard_article_confirm": "Willst du die Änderungen an diesem Artikel wirklich verwerfen?",
  "save_article_as_draft_confirm": "Möchtest du diesen Artikel als Entwurf speichern?",
  "please_enter_article_title": "Bitte gib zuerst einen Artikeltitel en.",
  "please_add_mandatory_fields": "Bitte alle Pflichtfelder ausfüllen",
  "product_label": "Produkt:",
  "no_companies_found": "Keini Firmene gefunden",
  "visible_to_all_followers": "Sichtbar für alle Kjuup Mitglieder",
  "only_visible_to_employees": "Nur für Mitarbäiter sichtbar",
  "something_went_wrong": "Etwas isch schief gelaufen, bitte versuche es erneut",
  "please_select_department": "Bitte Abteilung/Standort auswählen",
  "schedule": "Planen",
  "please_select_future_date_time": "Bitte wähle en zukünftiges Datum und eine zukünftige Uhrzeit für die Planung des Artikels.",
  "please_select_different_date_time": "Bitte wähle en anderes Datum oder eine andere Uhrzeit.",
  "please_select_later_time": "Bitte wähle eine Uhrzeit nach der aktuellen Zeit für heute.",
  "unpin_article": "Artikel lösen",
  "pin_article": "Artikel anpinnen",
  "and": "und",
  "others": "andere",
  "at": "um",
  "company_article": "Firmenartikel",
  "mute": "Stummschalten",
  "unmute": "Stummschaltung aufheben",
  "chat_muted_successfully": "Chat erfolgreich stummgeschaltet",
  "chat_unmuted_successfully": "Stummschaltung des Chats aufgehoben",
  "mute_chat_confirm": "Möchtest du diesen Chat wirklich stummschalten? Du erhältst keini Benachrichtigungen mehr für neue Nochrichte.",
  "unmute_chat_confirm": "Möchtest du die Stummschaltung dieses Chats wirklich aufheben? Du erhältst wieder Benachrichtigungen für neue Nochrichte.",
  "please_select_group_to_forward": "Bitte Gruppe zum Weiterleiten auswählen",
  "record_not_found": "Kei Datensatz gefunden!",
  "please_select_position": "Bitte Position auswählen",
  "delete_article_confirm": "Bist du sicher, dass du diesen Artikel löschen willst?",
  "delete_company_service_confirm": "Bist du sicher, dass du die Firmenleistung löschen möchtest?",
  "block_translation_confirm": "Willst du die automatische Übersetzungsfunktion in Projekten für Mitglieder der Firma blockieren",
  "unblock_translation_confirm": "Willst du die automatische Übersetzungsfunktion in Projekten für Mitglieder der Firma erlauben",
  "please_select_file": "Bitte wähle eine Datei zum Ufelade us",
  "role_in_building_industry": "Rolle in der Baubranche*",
  "invalid_email_address": "Ungültige E-Mail-Adresse",
  "please_enter_password": "Bitte gib en Passwort en",
  "password_change_email_sent": "Eine E-Mail wurde an deine Kjuup-E-Mail-Adresse gesendet. Bitte bestätige dein neues Passwort, indem du auf den Bestätigungslink in der E-Mail klickst.",
  "please_enter_username": "Bitte gib einen Benutzernamen en",
  "username_same_as_before": "Der Benutzername darf nöd mit dem vorherigen übereinstimmen",
  "profile_deleted_successfully": "Profil erfolgreich gelöscht",
  "hardware_requirements": "Hardware Anforderungen",
  "hardware_requirements_list": "• 4GB RAM<br/>• CPU Geschwindigkeit min. 2GHz<br/>• Windows 7 oder höher / alle Varianten macOS",
  "submitting": "Wird gesendet...",
  "signing_in": "Anmeldung läuft...",
  "please_enter_service_name": "Bitte gib einen Servicenamen en",
  "something_went_wrong_error": "Aaaah! Etwas isch schief gelaufen...",
  "something_went_wrong_try_again": "Entschuldigung, da isch etwas schief gelaufen. Versuche es erneut",
  "position_label": "Position:",
  "loading_room": "Projekt wird geladen...",
  "navigating_to_room": "Zum Projekt navigieren",
  "loading_chat": "Chat wird geladen...",
  "translate": "Übersetzen",
  "show_original": "Original anzeigen",
  "show_translation": "Übersetzung anzeigen",
  "click_to_show_original": "Klicken, um Original anzuzeigen",
  "click_to_show_translation": "Klicken, um Übersetzung anzuzeigen",
  "saving": "Spychere...",
  "language_selection_info": "Die Sprachauswahl wird für alle E-Mail Bestätigungen, die die Firma betreffen, verwendet.",
  "video_call": "Videoanruf",
  "audio_call": "Audioanruf",
  "nav_call": "Anruf",
  "nav_home": "Home",
  "nav_messages": "Nochrichte",
  "nav_todo": "Aufgaben",
  "nav_rooms": "Projekte",
  "nav_all_rooms": "Alli Projekt",
  "pinned_rooms_max": "Du chasch höggstens 10 Projekt ahefte.",
  "pinned_room_unpin": "Löse",
  "pinned_rooms_drop": "Zieh dis Projekt daane für e schnälli Uswahl",
  "nav_profile": "Profil",
  "nav_company": "Firmene",
  "nav_company_documents": "Dokumente",
  "nav_logout": "Abmälde",
  "add_member_title": "Mitglied hinzufügen",
  "continue_btn": "Wyter",
  "search_placeholder": "Suche",
  "no_members_found": "Keini Mitglieder gefunden",
  "unnamed_group": "Unbenannte Gruppe",
  "unnamed_room": "Unbenanntes Projekt",
  "all_members": "Alle",
  "room_label": "Projekt:",
  "subject_label": "Betreff:",
  "no_members": "Keini Mitglieder",
  "creating_structure": "Struktur wird erstellt",
  "opening_chat": "Chat wird geöffnet",
  "sending_request": "Anfrage wird gesendet",
  "updating_profile": "Profil wird aktualisiert",
  "loading_todo": "Aufgabe wird glade...",
  "task_updated": "Aufgabe aktualisiert",
  "error_updating_task": "Fehler beim Aktualisieren",
  "task_deleted": "Aufgabe gelöscht",
  "error_deleting_task": "Fehler beim Lösche",
  "delete_task_confirm": "Möchtest du diese Aufgabe wirklich löschen?",
  "delete_multiple_tasks_confirm": "Möchtest du wirklich {count} Aufgaben löschen?",
  "delete_selected_count": "Lösche ({count})",
  "todo_multi_delete": "Mehrere löschen",
  "todo_multi_delete_hint": "Aufgaben zum Lösche uswähle",
  "todos_deleted_count": "{count} Aufgaben glöscht",
  "todos_deleted_partial": "{ok} Aufgaben glöscht, {fail} fehlgschlage",
  "delete_only_own": "Du chasch nur Aufgaben lösche, wo du sälber erstellt hesch",
  "description_label": "Beschreibung",
  "description_placeholder": "Beschreibung eingeben...",
  "date_time_label": "Datum & Uhrzeit",
  "save_hint": "Strg+Enter zum Spychere, Esc zum Abbräche",
  "edit_label": "Bearbeiten",
  "delete_label": "Lösche",
  "todo_list_title": "Aufgaben",
  "tasks_count": "Aufgaben",
  "search_placeholder_todo": "Sueche...",
  "select_task_to_open_chat": "Wähle eine Aufgabe us, um den Chat zu öffnen",
  "today": "Heute",
  "time_suffix": "Uhr",
  "from_chat": "Quelle Aufgabe",
  "assigned_to": "Zugewiesen an",
  "assign_users": "Benutzer zuweisen",
  "assigned_users": "Zugewiesene Benutzer:",
  "no_users_assigned": "Keini Benutzer zugewiesen",
  "assign": "Zuweisen",
  "assign_to": "Zuweisen an...",
  "navigate_to_chat": "Zum Chat navigieren",
  "navigate_to_email": "Zur E-Mail navigieren",
  "show_original_message": "Quelle anzeigen",
  "hide_original_message": "Quelle ausblenden",
  "status_pending": "Ausstehend",
  "status_in_progress": "In Bearbeitung",
  "status_completed": "Abgeschlossen",
  "show": "Anzeigen",
  "todo_beta": "BETA",
  "todo_project_label": "Projektzuordnung:",
  "todo_room_none": "Kei Zuordnung",
  "todo_room_clear": "Projektzuordnung entferne",
  "todo_chat_label": "Chat:",
  "todo_assigned_by": "Zugewiesen von:",
  "todo_assigned_push": "Aufgabe zuegwise:",
  "todo_assigned_push_empty": "Dir wurde e neui Aufgabe zuegwise.",
  "todo_clear_all": "Alle löschen",
  "todo_unknown": "Unbekannt",
  "filter_all": "Alle",
  "filter_assigned_to_me": "Meine Aufgaben",
  "filter_assigned_by_me": "Delegiert",
  "completed_by": "Abgeschlossen von:",
  "verify_completion": "Bestätige",
  "back_into_in_progress": "Zrugg in Bearbeitung",
  "unassign_todo": "Aufgabe entferne",
  "unassign_label": "Entfernen",
  "search_or_select_project": "Projekt sueche oder uswähle...",
  "status_confirmed": "Bestätigt",
  "todo_confirmed": "Aufgabe bestätigt",
  "history": "Verlauf",
  "marked_as": "Markiert als",
  "at_date": "am",
  "at_time": "um",
  "all_todos": "Offeni Aufgaben",
  "confirmed_todos": "Bestätigti Aufgaben",
  "filter_pending": "Ausstehend",
  "filter_confirmed": "Bestätigt",
  "my_list": "Mein Tag",
  "todo_adjust_list": "Liste bearbeiten",
  "apply": "Anwenden",
  "move_back_in_progress": "Zrugg in Bearbeitung",
  "no_history_yet": "No kei Verlauf",
  "todo_status_updated": "Aufgabenstatus von {from} uf {to} aktualisiert",
  "todo_status_updated_from": "von",
  "todo_status_updated_to": "auf",
  "log_todo_created": "Aufgabe erstellt",
  "log_todo_confirmed": "Aufgabe bestätigt",
  "log_todo_deleted": "Aufgabe glöscht",
  "log_todo_updated": "Aufgabe aktualisiert",
  "log_description_updated": "Beschreibung aktualisiert",
  "log_deadline_updated": "Frist aktualisiert",
  "log_assigned_to": "Zugewiesen an {name}",
  "log_unassigned_from": "Zuweisung entfernt von {name}",
  "log_assignment_added": "Zuweisung hinzugefügt: {name}",
  "log_assignment_removed": "Zuweisung entfernt: {name}",
  "log_status_updated": "Status geändert von {from} auf {to}",
  "log_status_changed": "Status geändert",
  "log_status_changed_to": "Status geändert auf {status}",
  "log_changed_status_to": "Status geändert auf:",
  "log_for_user": "für Benutzer:",
  "log_user_updated_status": "Benutzer het de Aufgabenstatus aktualisiert",
  "log_changed_date_to": "Datum geändert auf:",
  "log_changed_description_to": "Beschreibung geändert auf:",
  "log_moved_to": "Verschoben nach {status}",
  "todo_filters": "Filter",
  "todo_filter_by_project": "Nach Projekt filtern",
  "todo_status": "Status",
  "todo_assignment": "Zuweisung",
  "todo_filter_by_user": "Nach zugewiesener Person filtern",
  "todo_active_filters": "Aktive Filter:",
  "todo_progress": "Fortschritt",
  "todo_my_list_empty": "Dein Tag isch leer",
  "todo_my_list_empty_hint": "Klicke auf die Schaltfläche oben, um Aufgaben hinzuzufügen",
  "create_poll": "Umfrage",
  "poll_question_label": "FRAGE",
  "poll_question_placeholder": "Frage stellen",
  "poll_options_label": "OPTIONEN",
  "poll_option": "Option",
  "poll_add_option": "Option hinzufügen",
  "poll_allow_multiple": "Mehrere Antworten erlauben",
  "poll_multiple_allowed": "Eine oder mehrere Optionen auswählen",
  "poll_select_option": "Eine Option auswählen",
  "poll_view_votes": "Abstimmung ansehen",
  "poll_vote_singular": "Stimme",
  "poll_vote_plural": "Stimmen",
  "poll_votes": "Abstimmungsergebnis",
  "poll_no_votes_yet": "No keini Stimmen",
  "transcript_label": "Transkription",
  "ai_generated_transcription": "KI-generierte Transkription",
  "transcript_start": "Sprachnachricht transkribieren",
  "transcript_transcribing": "Transkribierung...",
  "transcript_show": "Transkription anzeigen",
  "transcript_hide": "Transkription ausblenden",
  "transcript_redo": "Transkription wiederholen",
  "transcript_failed": "Transkription fehlgeschlagen",
  "transcript_no_result": "Kei Transkript erhalten",
  "transcript_step_listening": "Sprachnachricht wird angehört...",
  "transcript_step_processing": "Transkription läuft...",
  "transcript_step_creating": "Text wird erstellt...",
  "ai_transcript_tab": "AI-Transkript",
  "ai_transcript_info": "Nur verfügbar für Sprachnachrichten, die nach dem 09.03.2026 erstellt wurden.",
  "no_transcript_available": "Kei Transkript verfügbar.",
  "transcript_more": "...mehr",
  "transcript_less": "...weniger",
  "ki_transcript_voice_message": "KI-Transkript der Sprachnachricht",
  "ki_image_analysis": "KI-gestützte Bildanalyse",
  "document_analysis": "Dokumentenanalyse",
  "type_message": "Nochricht eingeben",
  "email_tab_messages": "Nochrichte",
  "email_tab_email": "E-Mail",
  "email_tab_messages_and_email": "Nochrichte & E-Mail",
  "email_tab_email_details": "E-Mail Details",
  "email_accounts": "E-Mail-Konten",
  "calendar_sync_title": "Kalender-Sync",
  "calendar_sync_info": "Synchronisiere automatisch alli Kjuup-Aufgaben mit dim Kalender.",
  "calendar_connect_google": "Google Kalender verbinden",
  "calendar_connect_outlook": "Outlook Kalender verbinden",
  "calendar_connect_apple_caldav": "Apple / CalDAV verbinden",
  "calendar_connect": "Verbinden",
  "calendar_connected": "Kalender verbunden",
  "calendar_connect_failed": "Kalenderverbindung fehlgeschlagen",
  "calendar_disconnected": "Kalender getrennt",
  "calendar_disconnect_confirm": "Diesen Kalender trennen? Bestehende Termine bleiben erhalten; die Synchronisation wird gestoppt.",
  "calendar_no_accounts": "No kei Kalender verbunden.",
  "calendar_sync_enabled": "Sync aktiv",
  "calendar_on_complete": "Wenn d Aufgabe erledigt isch",
  "calendar_on_complete_delete": "Kalendereintrag entfernen",
  "calendar_on_complete_mark": "Eintrag als erledigt markieren",
  "calendar_target": "Zielkalender",
  "calendar_refresh_list": "Aktualisieren",
  "calendar_auth_error": "Erneut verbinden erforderlich",
  "calendar_apple_hint": "Nutzen Sie Ihre Apple-ID-E-Mail und en app-spezifisches Passwort von appleid.apple.com.",
  "calendar_server_url": "CalDAV-Server-URL",
  "calendar_username": "Benutzername / E-Mail",
  "calendar_password": "Passwort / App-Passwort",
  "calendar_caldav_required": "Benutzername und Passwort sind erforderlich.",
  "calendar_caldav_server_required": "Server-URL isch für CalDAV erforderlich.",
  "calendar_auth_url_failed": "Autorisierungs-URL konnte nöd geladen wärde.",
  "calendar_syncing": "Kalender wird aktualisiert…",
  "calendar_sync_up_to_date": "Kalender isch aktuell",
  "calendar_sync_failed": "Synchronisierung fehlgeschlagen",
  "calendar_sync_complete": "Kalender aktualisiert",
  "calendar_sync_now": "Jetzt synchronisieren",
  "calendar_reconnect": "Erneut verbinden",
  "email_connect_gmail": "Gmail verbinden",
  "email_connect_outlook": "Outlook verbinden",
  "email_no_accounts": "Keini E-Mail-Konten verbunden",
  "email_no_accounts_hint": "Verbinde en E-Mail-Konto in deinen Profileinstellungen",
  "email_no_messages": "Keini E-Mails",
  "email_from": "Von",
  "email_to": "An",
  "email_subject": "Betreff",
  "email_disconnect": "Trennen",
  "email_disconnect_confirm": "Bist du sicher, dass du dieses E-Mail-Konto trennen möchtest? Alle synchronisierten E-Mails wärde entfernt.",
  "email_account_disconnected": "E-Mail-Konto erfolgreich getrennt",
  "email_account_disconnect_failed": "E-Mail-Konto konnte nöd getrennt wärde",
  "email_connecting": "Verbinde...",
  "email_account_connected": "Konto erfolgreich verbunden",
  "email_connection_error": "Verbindungsproblem",
  "email_connection_error_hint": "Dieses Konto konnte nöd synchronisiert wärde. Bitte erneut verbinden, damit neue E-Mails wieder ankommen.",
  "email_reconnect": "Erneut verbinden",
  "email_edit_settings": "Iistellige anpassen",
  "email_imap_edit_title": "IMAP-Konto bearbeiten",
  "email_imap_edit_hint": "E-Mail-Adresse oder Passwort aktualisieren und speichern, um das Konto erneut zu verbinden.",
  "email_imap_save": "Spychere & verbinden",
  "email_reconnect_banner": "En oder mehrere E-Mail-Konten müend erneut verbunden wärde.",
  "email_reconnect_manage": "In Iistellige beheben",
  "email_connection_warning": "D E-Mail-Verbindig für {email} funktioniert nöd meh richtig. Bitte erneut verbinden, damit neui E-Mails wieder aachömed.",
  "email_connection_warning_multi": "D E-Mail-Verbindige für {emails} funktioniered nöd meh richtig. Bitte erneut verbinden, damit neui E-Mails wieder aachömed.",
  "email_connected_accounts": "Verbundene Konten",
  "email_sync_info": "Beim Verbinden eines E-Mail-Kontos wärde standardmässig die E-Mails des letzten Monats synchronisiert. Sie chönd den Synchronisierungszeitraum unten erweitern.",
  "email_sync_3_months": "Letzte 3 Monate sync.",
  "email_sync_6_months": "Letzte 6 Monate sync.",
  "email_syncing": "Synchronisiere...",
  "email_sync_already_done": "{months} Monate bereits synchronisiert",
  "email_sync_more": "Weitere Monate synchronisieren",
  "email_sync_retry": "Monate erneut synchronisieren",
  "email_sync_all_done": "Alle Monate synchronisiert",
  "email_sync_backfill_started": "Ältere E-Mails wärde nachgeladen — bei grossen Postfächern cha das einige Minuten dauern…",
  "email_sync_backfill_hint": "Fehlende ältere E-Mails in diesem Zeitraum nachladen",
  "email_sync_retry_3_months": "Letzte 3 Monate erneut sync.",
  "email_sync_retry_6_months": "Letzte 6 Monate erneut sync.",
  "email_syncing_account": "Konto wird synchronisiert, dies cha einige Minuten dauern…",
  "email_signature": "Signatur",
  "email_signature_placeholder": "Geben Sie Ihre E-Mail-Signatur en...",
  "email_signature_save": "Spychere",
  "email_signature_saved": "Gespeichert",
  "email_add_account": "Konto hinzufügen",
  "email_folder_inbox": "Posteingang",
  "email_folder_spam": "Spam",
  "email_folder_drafts": "Entwürfe",
  "email_folder_sent": "Gesendete Elemente",
  "email_folder_deleted": "Gelöschte Elemente",
  "email_folder_archive": "Archiv",
  "email_folder_outbox": "Postausgang",
  "email_custom_folders": "Ordner",
  "email_create_folder": "Neuer Ordner",
  "email_delete_folder": "Ordner löschen",
  "email_folder_name_placeholder": "Ordnername",
  "email_folder_created": "Ordner erstellt",
  "email_move_to": "Verschieben nach",
  "email_moved_to_folder": "In Ordner verschoben",
  "email_move_to_inbox": "In Posteingang verschieben",
  "email_confirm_delete_folder": "Möchten Sie diesen Ordner wirklich löschen?",
  "email_refresh": "Aktualisieren",
  "email_folder_not_synced": "Dieser Ordner wird nöd automatisch synchronisiert.",
  "email_sync_folder": "Jetzt synchronisieren",
  "email_go_to_settings": "Zu den Iistellige",
  "email_date": "Datum",
  "email_reply": "Antworten",
  "email_forward": "Weiterleiten",
  "email_delete": "Lösche",
  "email_not_spam": "Kei Spam",
  "email_not_spam_success": "E-Mail in den Posteingang verschoben.",
  "email_not_spam_failed": "Verschieben in den Posteingang fehlgeschlagen.",
  "email_delete_confirm": "Sind Sie sicher, dass Sie diese E-Mail löschen möchten?",
  "email_delete_from_folder": "Möchten Sie wirklich us {folder} löschen?",
  "email_delete_permanent_from_folder": "Möchten Sie wirklich endgültig us {folder} löschen? Diese Aktion cha nöd rückgängig gemacht wärde.",
  "email_save_draft_confirm": "Möchten Sie diese E-Mail als Entwurf speichern?",
  "email_save_draft": "Entwurf speichern",
  "email_discard": "Verwerfen",
  "email_back_to_compose": "Zrugg zum Schriibe",
  "email_draft_saved": "Entwurf gespeichert.",
  "email_saving_draft": "Entwurf wird gespeichert...",
  "email_draft_save_failed": "Entwurf konnte nöd gespeichert wärde.",
  "email_loading": "E-Mails wärde geladen...",
  "email_imap_title": "IMAP",
  "email_imap_hint": "Verbinde en beliebiges E-Mail-Konto per IMAP.",
  "email_imap_user": "E-Mail",
  "email_imap_password": "Passwort",
  "email_imap_connect_btn": "IMAP-Konto verbinden",
  "email_imap_required": "Bitte E-Mail und Passwort eingeben.",
  "email_imap_failed": "IMAP-Verbindung fehlgeschlagen.",
  "email_imap_manual_toggle": "Manuelle Servereinstellungen",
  "email_imap_host": "IMAP-Server (z.B. imap.ionos.de)",
  "email_imap_port": "Port",
  "email_imap_incoming": "Posteingang (IMAP)",
  "email_smtp_outgoing": "Postausgang (SMTP)",
  "email_smtp_host": "SMTP-Server (z.B. smtp.ionos.de)",
  "email_smtp_port": "Port",
  "email_send_btn": "Senden",
  "email_sent": "E-Mail gesendet.",
  "email_sending": "E-Mail wird gesendet...",
  "deleting_emails": "E-Mail wird gelöscht...",
  "marking_unread": "Als ungelesen markieren...",
  "email_send_failed": "E-Mail konnte nöd gesendet wärde.",
  "email_compose_to_required": "Empfänger (An) isch erforderlich.",
  "email_compose_body_required": "Bitte Betreff oder Nochricht eingeben.",
  "email_compose_placeholder": "Nochricht schreiben...",
  "email_original_message": "Originalnachricht",
  "email_forwarded_message": "Weitergeleitete Nochricht",
  "email_archived": "Archiviert",
  "email_mark_spam": "Als Spam markieren",
  "email_marked_spam": "In Spam verschoben",
  "email_group_today": "Heute",
  "email_group_yesterday": "Gestern",
  "email_group_this_week": "Diese Woche",
  "email_group_earlier": "Älter",
  "email_search": "Sueche",
  "email_search_placeholder": "In diesem Ordner suchen",
  "email_no_results": "Keini passenden Nochrichte",
  "email_clear_search": "Suche zurücksetzen",
  "email_star": "Markieren",
  "email_unstar": "Markierung entfernen",
  "email_starred": "Markiert",
  "email_folder_starred": "Markiert",
  "email_select": "Auswählen",
  "email_attachment_singular": "Anhang",
  "email_attachment_plural": "Anhänge",
  "email_back": "Zrugg",
  "email_download": "Abelade",
  "email_download_all": "Alle herunterladen",
  "email_download_all_zip": "Alle als ZIP herunterladen",
  "email_download_failed": "Download fehlgeschlagen",
  "email_close": "Schliesse",
  "email_preview": "Vorschau",
  "email_preview_not_available": "Vorschau nöd verfügbar",
  "email_preview_failed": "Vorschau nöd verfügbar",
  "email_loading_preview": "Vorschau wird geladen...",
  "email_no_subject": "(Kei Betreff)",
  "email_mark_unread_failed": "E-Mail(s) konnten nöd als ungelesen markiert wärde.",
  "email_delete_failed": "E-Mail(s) konnten nöd gelöscht wärde.",
  "email_classify_banner": "{count} E-Mail(s) von neuen Absendern müend klassifiziert wärde",
  "email_classify_banner_inline": "{count} E-Mail(s) von neuen Absendern — unten jeweils einem Projekt zuordnen oder als Spam markieren",
  "email_classify_review": "Prüfen",
  "email_classify_title": "Absender zuordnen",
  "email_classify_question_project": "Soll diese E-Mail einem Projekt zugeordnet wärde?",
  "email_project_name": "Projektname",
  "email_classify_suggested": "Vorschlag",
  "email_remember_sender": "Diesen Absender für zukünftige E-Mails merken",
  "email_account_default_project": "E-Mails dieses Kontos immer diesem Projekt zuordnen",
  "email_classify_associate": "Projekt zuordnen",
  "email_classify_missing": "Nöd zuegordnet",
  "email_tag_daily_briefing": "Tagesbericht",
  "email_project_navigate": "Zum Projekt wechseln",
  "email_project_change": "Projektzuordnung ändern",
  "email_project_remove": "Projektzuordnung entfernen",
  "email_project_removed": "Projektzuordnung entfernt",
  "email_classify_question_spam": "Isch dies SPAM oder Werbung?",
  "email_classify_mark_spam": "In Spam verschieben",
  "email_classify_skip": "Vorerst überspringen",
  "email_classify_need_project": "Bitte einen Projektnamen eingeben",
  "email_classify_refile_question": "Soll ich die E-Mail wieder im Projekt '{name}' ablegen?",
  "email_classify_refile_yes": "Ja, in '{name}' ablegen",
  "email_classify_save_question": "Soll ich die E-Mail im Projekt '{name}' abspeichern?",
  "email_classify_save_yes": "Ja, im Projekt '{name}' speichern",
  "email_saved_to_project": "E-Mail im Projekt gespeichert",
  "email_saved_to_project_similar": "E-Mail im Projekt gespeichert. {count} ähnlechi E-Mails sind au zuegordnet worde.",
  "email_in_project": "Im Projekt",
  "email_classify_choose_other": "Anderes Projekt wählen",
  "email_new_room_title": "Neues Projekt erstellen",
  "email_new_room_name": "Projektname",
  "email_new_room_type": "Projekttyp",
  "email_new_room_external": "Extern",
  "email_new_room_internal": "Intern",
  "email_new_room_company": "Firmenverbindung auswählen",
  "email_new_room_company_info": "Wähle die Firmenverbindung us, mit der du im Projekt aufgeführt wärde willst. Diese wird anderen Mitgliedern angezeigt.",
  "email_new_room_kjuup_company": "Kjuup+ Firma uswählen",
  "email_new_room_kjuup_company_info": "S intern Projekt ghört zu dere Kjuup+ Firma.",
  "email_new_room_internal_unavailable": "Tritt ere Kjuup+ Firma bi, zum intern Projekt z erstelle",
  "email_new_room_create": "Projekt erstellen & E-Mail speichern",
  "email_room_tab": "E-Mail",
  "email_room_tab_all": "Alli",
  "email_room_tab_todos": "Ufgabe",
  "email_room_tab_briefings": "Tagesbericht",
  "email_room_all_empty": "No keini Nachrichte in diesem Projekt",
  "email_room_briefings_empty": "Keini Tagesberichte in diesem Projekt",
  "email_room_empty": "No keini E-Mails in diesem Projekt",
  "email_room_sent_empty": "No keini gesendeten E-Mails in diesem Projekt",
  "email_room_drafts_empty": "No keini Entwürfe in diesem Projekt",
  "email_room_inbox": "Posteingang",
  "email_room_sent": "Gesendet",
  "email_room_drafts": "Entwürfe",
  "email_room_remove": "Us Projekt entfernen",
  "email_room_remove_confirm": "Diese E-Mail us dem Projekt entfernen?",
  "email_room_briefing_remove_confirm": "Willst du de Tagesbericht wirklich entfernen?",
  "email_room_removed": "E-Mail us Projekt entfernt",
  "email_compose_project": "Projektzuordnung in Kjuup",
  "email_compose_project_info": "Diese Information isch nur für dich sichtbar und wird nöd mit der E-Mail versendet.",
  "email_compose_project_placeholder": "Projektname",
  "email_no_sender": "(unbekannter Absender)",
  "email_no_recipient": "(kei Empfänger)",
  "email_attachments_tab": "E-MAIL",
  "select_attachments": "Anhänge auswählen",
  "email_attachments_empty": "No keini E-Mail-Anhänge",
  "email_move_to_room": "In Projekt verschieben",
  "email_attachment_moved": "E-Mail-Anhang verschoben",
  "email_attachment_removed": "E-Mail-Anhang entfernt",
  "email_attachment_remove_confirm": "Ausgewählte E-Mail-Anhänge us diesem Projekt entfernen?",
  "email_no_other_rooms": "Keini anderen Projekte verfügbar",
  "email_classify_rules_title": "E-Mail-Projektzuordnung",
  "email_default_project_per_account": "Standardprojekt pro Konto",
  "email_sender_rules": "Absenderregeln",
  "email_spam_blocklist": "Spam-Sperrliste",
  "email_no_default": "Keins",
  "email_select_project": "Projekt auswählen",
  "info": "Info",
  "email_default_project_info": "Wenn en E-Mail-Konto mit einem bestimmten Projekt verknüpft isch, wärde alle eingehenden E-Mails dieses Kontos automatisch diesem Projekt zugeordnet – du wirst nöd zur Projektzuordnung aufgefordert. Leer lassen, um jede E-Mail einzeln einem Projekt zuzuordnen.",
  "email_account_project_title": "Konto mit Projekt verbinden?",
  "email_account_project_question": "Wird dieses E-Mail-Konto ausschliesslich für ein bestimmtes Projekt verwendet? Falls ja, wählen Sie bitte das Projekt us. Alle eingehenden E-Mails wärde diesem Projekt anschliessend automatisch zugeordnet.",
  "email_account_project_name_placeholder": "Name",
  "email_account_create_room": "Neues Projekt erstellen",
  "email_account_create_company": "Firma auswählen",
  "email_account_create_submit": "Projekt erstellen & verknüpfen",
  "email_account_project_link": "Konto mit Projekt verknüpfen",
  "email_account_project_skip": "Nein, jede E-Mail einzeln klassifizieren",
  "email_account_project_linked": "Konto mit Projekt verknüpft",
  "project_confirm_title": "Meintest du dieses Projekt?",
  "project_confirm_text": "Der Name \"{typed}\" ähnelt stark dem bestehenden Projekt \"{existing}\". Möchtest du das bestehende Projekt verwenden oder en neues erstellen?",
  "project_confirm_use_existing": "\"{name}\" verwenden",
  "project_confirm_create_new": "Neu \"{name}\" erstellen",
  "attachment": "Anhang",
  "attachments": "Anhänge",
  "media_send_disabled": "Vom Administrator deaktiviert.",
  "todo_bookmarked": "Ufgab isch vorgmerkt worde",
  "bookmarked_todos": "Vorgmerkti Ufgabe",
  "needs_date": "Termin zuweise",
  "needs_date_hint": "Leg en Termin fescht, zum d'Ufgaab iizplane",
  "bookmarked_no_mylist": "Vorgmerkti Ufgabe chönd nöd zur Liste hinzuefüegt wärde",
  "bookmark_removed": "Vorgmerkti Ufgab entfernt.",
  "bookmark_already_todo": "Die Aufgabe wurde scho bearbeitet und blibt bestah",
  "new_label": "Neu",
  "no_new_todos": "Keini neue Aufgaben",
  "filter_email": "E-Mail",
  "filter_reports": "Tagesberichte",
  "filter_kjuup_messages": "Kjuup",
  "filter_direct_messages": "Direktnachrichten",
  "my_notes": "My Space",
  "filter_internal_groups": "Interne Gruppen-Chats",
  "filter_external_groups": "Externe Gruppen-Chats",
  "filter_group_chats": "Gruppen-Chats",
  "filter_groups_internal": "Intern",
  "filter_groups_external": "Extern",
  "filter_unread_only": "Nur ungelesen",
  "email_select_all": "Alle auswählen",
  "email_deselect_all": "Auswahl aufheben",
  "email_reply_all": "Allen antworten",
  "email_reply_placeholder": "Antwort eingeben...",
  "email_forward_placeholder": "Nochricht hinzufügen...",
  "email_edit_draft": "Entwurf bearbeiten",
  "email_attach": "Anhängen",
  "email_attachment_from_original": "Us Originalnachricht",
  "email_remove": "Entfernen",
  "email_drop_files": "Dateien zum Anhängen ablegen",
  "email_loading_attachments": "Anhänge wärde geladen...",
  "email_archive": "Archivieren",
  "mark_unread": "Als ungelesen markieren",
  "mark_read": "Als gelesen markieren",
  "email_all_accounts": "Alle Konten",
  "email_error": "Fehler",
  "email_delete_email_failed": "E-Mail konnte nöd gelöscht wärde.",
  "enter_url": "URL eingeben",
  "kjuup_io": "Kjuup.io",
  "kjuup_io_manage_subscription": "Abonnement verwalten",
  "kjuup_io_subscribe_now": "Jetzt abonnieren",
  "kjuup_io_subscribe_now_short": "Abonnieren",
  "kjuup_io_hero_subtitle": "Upgrade, um Premium-Funktionen freizuschalten und mehr herauszuholen.",
  "kjuup_io_trial_badge": "1 MONAT KOSTENLOS TESTEN",
  "pro_auth_register_kjuup_io_title": "Registrierung Kjuup.io",
  "pro_auth_register_kjuup_io_sub": "Mit Ihrem Konto startet sofort Ihre kostenlose Kjuup.io-Testphase – ohne Zahlungsdaten. Wir senden Ihnen einen Link, um Ihre E-Mail-Adresse zu bestätigen.",
  "kjuup_io_trial_title": "Kjuup.io Premium freischalten",
  "kjuup_io_trial_subtitle": "Verbinde deine E-Mail, erhalte KI-gestützte Antwortvorschläge und synchronisiere deine Aufgaben automatisch mit deinem Kalender.",
  "kjuup_io_trial_no_payment": "Heute keini Zahlung.",
  "kjuup_io_trial_trust": "Heute keini Zahlung. Es wärde keini Kreditkartendaten abgefragt, bevor das Bezahllabo startet.",
  "kjuup_io_after_trial_monthly": "Nach der Testphase: {price}/Monat",
  "kjuup_io_after_trial_yearly": "Nach der Testphase: {price}/Jahr",
  "kjuup_io_price_per_month": "{price}/Monat",
  "kjuup_io_price_per_year": "{price}/Jahr",
  "kjuup_io_start_free_trial": "Jetzt kostenlos testen",
  "kjuup_io_trial_footnote": "Heute keini Zahlung. Danach {price}. Jederzeit kündbar.",
  "kjuup_io_feature_email": "Alle E-Mail Konten direkt in Kjuup verwalten",
  "kjuup_io_feature_assign": "E-Mails und Anlagen automatisiert Projekten zuordnen",
  "kjuup_io_feature_ai": "KI schreibt Antworten – du bestätigst nur",
  "kjuup_io_feature_tasks": "Aufgaben & Kalender immer automatisch aktuell",
  "kjuup_io_company_managed_title": "Von Ihrer Firma verwaltet",
  "kjuup_io_company_managed_body": "Kjuup.io für Ihre Kjuup+-Firma wird im Admin Panel gebucht und abgerechnet. Bitte wenden Sie sich an {admins}, um Zugang zu erhalten.",
  "kjuup_io_company_managed_body_short": "Bitten Sie Ihren Firmene-Admin, Ihnen im Admin Panel einen Kjuup.io-Platz zuzuweisen.",
  "kjuup_io_company_managed_body_short_admins": "Bitten Sie {admins} mit, Ihnen im Admin Panel einen Kjuup.io-Platz zuzuweisen.",
  "kjuup_io_company_seat_active": "Ihr Firmenplatz isch aktiv.",
  "kjuup_io_open_admin_panel": "Admin Panel öffnen",
  "kjuup_io_open_admin_panel_short": "Admin Panel",
  "kjuup_io_company_trial_ended_title": "Kostenlose Testphase beendet!",
  "kjuup_io_company_trial_ended_body": "Das Kjuup.io Abo cha über das Admin Center zugewiesen wärde.",
  "kjuup_io_company_trial_ended_contact_admins": "Das Kjuup.io Abo cha von {admins} über das Admin Center zugewiesen wärde.",
  "kjuup_io_todo_calendar_trial_ended_admin": "Kalender-Sync · Admin kontaktieren",
  "kjuup_io_your_company": "Ihre Firma",
  "kjuup_io_choose_plan": "Plan wählen",
  "kjuup_io_plan_monthly": "Monatlich",
  "kjuup_io_plan_yearly": "Jährlich",
  "kjuup_io_plan_monthly_desc": "Monatlich abgerechnet · jederzeit kündbar",
  "kjuup_io_plan_yearly_desc": "Spare {pct}% mit jährlicher Buchung",
  "kjuup_io_save_badge": "{pct}% SPAREN",
  "kjuup_io_per_month_annual": "{price} / Monat · Spare {pct}% mit jährlicher Buchung",
  "kjuup_io_subscribe": "Abonnieren",
  "kjuup_io_secured_stripe": "Gesichert durch Stripe · jederzeit kündbar",
  "kjuup_io_your_subscription": "DEIN ABO",
  "kjuup_io_status_active": "AKTIV",
  "kjuup_io_status_cancels_soon": "ENDEN BALD",
  "kjuup_io_status_switch_scheduled": "WECHSEL GEPLANT",
  "kjuup_io_label_plan": "Plan",
  "kjuup_io_label_price": "Preis",
  "kjuup_io_label_status": "Status",
  "kjuup_io_label_renews": "Verlängert am",
  "kjuup_io_label_access_until": "Zugang bis",
  "kjuup_io_switching_to": "Wechsel zu {plan} am {date}",
  "kjuup_io_cancel_pending_note": "Dein Abonnement isch zur Kündigung vorgemerkt und verlängert sich nöd. Du behältst den Zugang bis zum oben genannten Datum.",
  "kjuup_io_resume": "Abonnement fortsetzen",
  "kjuup_io_switch_to_plan": "Zu {plan} wechseln",
  "kjuup_io_undo_switch": "Geplanten Wechsel rückgängig",
  "kjuup_io_cancel_subscription": "Abonnement kündigen",
  "kjuup_io_switch_modal_title": "Zu {plan} wechseln?",
  "kjuup_io_billed_yearly": "Jährlich abgerechnet",
  "kjuup_io_billed_monthly": "Monatlich abgerechnet",
  "kjuup_io_switch_modal_note": "Startet am {date}, wenn dein aktueller {plan}-Plan endet. Heute keini Gebühr — du behältst deinen aktuellen Plan bis dahin.",
  "kjuup_io_confirm_switch": "Wechsel bestätigen",
  "kjuup_io_not_now": "Nöd jetzt",
  "kjuup_io_cancel_modal_title": "Abonnement kündigen?",
  "kjuup_io_cancel_modal_note": "Du behältst den Zugang zu Kjuup.io bis zum Ende deines aktuellen Abrechnungszeitraums. Danach verlängert es sich nöd.",
  "kjuup_io_cancel_modal_note_with_date": "Du behältst den Zugang zu Kjuup.io bis zum Ende deines aktuellen Abrechnungszeitraums ({date}). Danach verlängert es sich nöd.",
  "kjuup_io_cancel_plan": "Plan kündigen",
  "kjuup_io_keep_subscription": "Abonnement behalten",
  "kjuup_io_toast_payment_failed": "Zahlung fehlgeschlagen",
  "kjuup_io_toast_activating": "Zahlung erhalten. Abonnement wird aktiviert…",
  "kjuup_io_toast_activating_soon": "Zahlung erhalten. Dein Abonnement wird in Kürze aktiviert.",
  "kjuup_io_toast_cancel_period": "Dein Abonnement endet zum Periodenende",
  "kjuup_io_toast_cancel_fail": "Abonnement konnte nöd gekündigt wärde",
  "kjuup_io_toast_switch_scheduled": "Du wechselst zum {plan}-Plan, wenn die aktuelle Periode endet",
  "kjuup_io_toast_switch_fail": "Planwechsel nöd möglich",
  "kjuup_io_toast_resumed": "Dein Abonnement verlängert sich weiter",
  "kjuup_io_toast_resume_fail": "Abonnement konnte nöd fortgesetzt wärde",
  "kjuup_io_toast_undo": "Geplanter Planwechsel abgebrochen",
  "kjuup_io_toast_undo_fail": "Geplanter Wechsel konnte nöd abgebrochen wärde",
  "kjuup_io_email_locked_body": "E-Mail isch Teil von Kjuup.io. Aktiviere einen Plan, um den E-Mail-Tab zu nutzen.",
  "kjuup_io_connect_email": "E-Mail mit Kjuup.io verbinden",
  "kjuup_io_activate_to_connect_email": "Kjuup.io aktivieren, um E-Mail-Konten zu verbinden",
  "kjuup_io_activate_to_sync_calendar": "Kjuup.io aktiviere, zum Aufgaben mit mim Kalender z synchronisiere",
  "kjuup_io_todo_calendar_chip": "Kalender-Sync · Kjuup.io aktivieren",
  "kjuup_io_todo_calendar_nudge": "Aufgabe mit Kalender synchronisiere?",
  "kjuup_io_todo_calendar_nudge_cta": "Kjuup.io aktivieren",
  "kjuup_io_todo_calendar_trial_ended_note": "Kalender-Sync · Abonnieren",
  "kjuup_io_todo_connect_calendar_banner": "Kalender verbinden",
  "kjuup_io_todo_connect_calendar_cta": "Iistellige",
  "kjuup_io_trial_no_card": "Es wärde keini Kreditkartendaten abgefragt, bevor das Bezahlabo startet.",
  "kjuup_io_status_trialing": "TESTPHASE",
  "kjuup_io_trial_days_left": "No {days} Tage in deiner kostenlosen Testphase",
  "kjuup_io_trial_left_hours": "No {count} Stunde",
  "kjuup_io_trial_left_hour": "No 1 Stund",
  "kjuup_io_trial_left_minutes": "No {count} Minute",
  "kjuup_io_trial_left_minute": "No 1 Minute",
  "kjuup_io_trial_left_seconds": "No {count} Sekunde",
  "kjuup_io_trial_left_second": "No 1 Sekunde",
  "kjuup_io_trial_ending_now": "Dini Testphase gaht grad z Änd…",
  "kjuup_io_request_timeout": "D Verbindig isch abgloffe. Bitte probier es nomal.",
  "kjuup_io_info_days_free": "{days} Tage vollständig kostenlos – dein Abo beginnt erst nach der Testphase.",
  "kjuup_io_discount_total": "Dis Rabatt: {percent} %",
  "kjuup_io_discount_company": "{company}: {percent} %",
  "kjuup_io_discount_personal": "Persönlich: {percent} %",
  "kjuup_io_trial_days_short": "{days} Tage verbleibend",
  "kjuup_io_trial_ends_tomorrow": "Deine kostenlose Testphase endet morgen",
  "kjuup_io_trial_ends_today": "Deine kostenlose Testphase endet heute",
  "kjuup_io_trial_ends_today_short": "Endet heute",
  "kjuup_io_trial_card_title": "Ihr Kjuup.io-Testzeitraum endet in {days} Tagen",
  "kjuup_io_trial_card_title_today": "Ihr Kjuup.io-Testzeitraum endet heute",
  "kjuup_io_trial_card_subtitle": "Upgraden Sie jetzt, um alle Funktionen weiter zu nutzen.",
  "kjuup_io_trial_card_progress": "{days} von {total} Testtagen verbleibend",
  "kjuup_io_trial_card_cta": "Jetzt upgraden",
  "kjuup_io_trial_card_days_unit": "TAGE",
  "kjuup_io_trial_card_day_unit": "TAG",
  "kjuup_io_banner_dismiss": "Schliesse",
  "kjuup_io_billing_after_trial": "Die Abrechnung beginnt nach Ende der Testphase am {date}.",
  "kjuup_io_trial_ended_title": "Deine kostenlose Testphase isch beendet",
  "kjuup_io_trial_ended_body": "Abonniere Kjuup.io, um E-Mail und weitere Premium-Funktionen weiter zu nutzen.",
  "kjuup_io_subscribe_to_continue": "Jetzt abonnieren, um fortzufahren",
  "kjuup_io_trial_active_title": "Du bist in der kostenlosen Testphase",
  "kjuup_io_trial_active_subtitle": "Wähle einen Plan und abonniere — die Abrechnung beginnt am Ende der Testphase.",
  "kjuup_io_toast_trial_started": "Deine kostenlose Testphase het begonnen",
  "kjuup_io_toast_trial_fail": "Testphase konnte nöd gestartet wärde",
  "kjuup_io_trial_try_month": "Teste Kjuup.io einen Monat kostenlos.",
  "kjuup_io_per_month": "pro Monat",
  "kjuup_io_price_month_line": "{price} / Monat",
  "kjuup_io_billed_annually_amount": "{price} jährlich abgerechnet",
  "kjuup_io_save_yearly": "Spare {pct}% mit jährlicher Abrechnung.",
  "kjuup_io_save_amount_year": "Spare {price} pro Jahr",
  "kjuup_io_savings_pct": "{pct}% Ersparnis",
  "kjuup_io_features_title": "Was du bekommst:",
  "kjuup_io_info_one_month_free": "Einen Monat kostenlos",
  "kjuup_io_info_plan_after_trial": "Dein gewähltes Abonnement beginnt nach der Testphase.",
  "kjuup_io_info_cancel_trial": "Während der Testphase jederzeit kündbar.",
  "kjuup_io_info_no_card": "Keini Kreditkarte erforderlich – starte sofort, ohne Zahlungsdaten anzugeben.",
  "kjuup_io_info_cancel_anytime": "Jederzeit kündbar – keini Bindung, kei Risiko.",
  "kjuup_io_cta_plan_begins": "Dein gewählter Plan beginnt nach der kostenlosen Testphase.",
  "kjuup_io_billing_period_aria": "Abrechnungszeitraum",
  "kjuup_io_subscription_info_title": "Abo-Informationen",
  "kjuup_io_first_payment_on": "Erste Zahlung am {date}.",
  "kjuup_io_renews_on": "Verlängert am {date}.",
  "kjuup_io_toast_card_saved": "Zahlungsmethode gespeichert. Abrechnung erfolgt am Ende der Testphase.",
  "article_new_badge": "NEU",
  "article_new_posts": "{0} neue Beiträge",
  "documents": "Dokumente",
  "add_documents": "Dokumente hinzufügen",
  "no_preview_available": "Keini Vorschau verfügbar",
  "no_preview_hint": "Dieser Dateityp cha nöd in der Vorschau angezeigt wärde, wird aber trotzdem gesendet.",
  "max_documents_reached": "Du kannst bis zu 10 Dokumente gleichzeitig anhängen.",
  "open_file": "Datei abelade",
  "spreadsheet_preview_truncated": "Die erschte 250 Ziile werden aazeigt",
  "twofa_title": "Zwei-Faktor-Authentifizierung",
  "twofa_method_totp": "Authenticator-App",
  "twofa_method_sms": "SMS",
  "twofa_method_email": "E-Mail",
  "twofa_enter_app": "Gib de 6-stellige Code us dynere Authenticator-App ii.",
  "twofa_enter_sms": "Gib de 6-stellige Code ii, wo mer per SMS gschickt händ.",
  "twofa_enter_email": "Gib de 6-stellige Code ii, wo mer a dyni E-Mail gschickt händ.",
  "twofa_resend": "Code nomal sände",
  "twofa_try_another": "Anderi Methode probiere",
  "twofa_remember_device": "Uf däm Gerät 30 Täg nümme froge",
  "twofa_sent": "Mir händ en Code gschickt.",
  "twofa_invalid_code": "De Code isch falsch. Bitte nomal probiere.",
  "twofa_something_wrong": "Öppis isch schiefloufe. Bitte nomal probiere.",
  "twofa_method_unavailable": "Die Methode isch nöd verfüegbar.",
  "twofa_on_desc": "D Zwei-Faktor-Authentifizierung isch a. Bi jedere Aamäldig bruchsch en Code.",
  "twofa_off_desc": "Füeg nach em Passwort en zweite Schritt dezue. Authenticator-Apps sind am sicherschte.",
  "twofa_methods": "Methode",
  "twofa_on": "A",
  "twofa_add": "Dezuefüege",
  "twofa_default_method": "Standardmethode",
  "twofa_default": "Standard",
  "twofa_turn_off": "Abstelle",
  "twofa_disable_hint": "Gib dis Passwort und en aktuelle Code ii, zum d Zwei-Faktor-Authentifizierung abzstelle.",
  "twofa_disable_need": "Gib dis Passwort und en Bestätigungscode ii.",
  "twofa_code_placeholder": "6-stellige Code oder Backup-Code",
  "twofa_send_code": "Code sände",
  "twofa_primary_updated": "Standardmethode isch aktualisiert.",
  "twofa_disabled": "D Zwei-Faktor-Authentifizierung isch jetz ab.",
  "twofa_enabled": "D Zwei-Faktor-Authentifizierung isch jetz a.",
  "twofa_totp_help": "Scann de QR-Code mit Google Authenticator, Authy oder 1Password. Du chasch de Schlüssel au vo Hand iigää.",
  "twofa_secret_copied": "Schlüssel kopiert",
  "twofa_sms_help": "Gib dyni Mobilnummere im internationale Format ii. Mir schicked en 6-stellige Code per SMS.",
  "twofa_email_help": "Mir schicked en 6-stellige Code a d E-Mail-Adräss vo dim Konto.",
  "twofa_backup_title": "Backup-Codes",
  "twofa_backup_help": "Bewahr diei Einmal-Codes sicher uf. Jede Code cha eimal brucht werde, wänn s Handy verlore geit.",
  "twofa_copy_codes": "Codes kopiere",
  "twofa_codes_copied": "Backup-Codes kopiert",
  "twofa_regenerate": "Neui Backup-Codes erstelle",
  "twofa_regenerate_hint": "Damit wärde ungenutzti Backup-Codes ersetzt. Gib dis Passwort und en aktuelle Code ii.",
  "twofa_backup_remaining": "{n} ungenutzti Backup-Codes übrig",
  "twofa_new_codes": "Neui Backup-Codes",
  "twofa_sms_unavailable": "SMS-Codes sind no nöd verfügbar.",
  "todoist_sync_title": "Todoist",
  "todoist_sync_info": "Zugewiesene Kjuup-Aufgaben werden in ein Projekt „Kjuup“ in deinem Todoist kopiert. Änderungen in Todoist werden nicht zurückkopiert.",
  "todoist_connect": "Todoist verbinden",
  "todoist_connected": "Todoist verbunden",
  "todoist_connect_failed": "Todoist-Verbindung fehlgeschlagen",
  "todoist_disconnect": "Trennen",
  "todoist_disconnected": "Todoist getrennt",
  "todoist_disconnect_confirm": "Todoist trennen? Bereits angelegte Aufgaben bleiben in Todoist. Die Synchronisierung stoppt.",
  "todoist_sync_now": "Jetzt synchronisieren",
  "todoist_syncing": "Wird synchronisiert…",
  "todoist_sync_done": "Synchronisierung abgeschlossen",
  "todoist_sync_failed": "Synchronisierung fehlgeschlagen",
  "todoist_auth_error": "Verbinde Todoist erneut, um weiter zu synchronisieren.",
  "todoist_last_sync": "Letzte Synchronisierung",
  "todoist_not_connected": "Todoist ist nicht verbunden",
  "todoist_auth_url_failed": "Die Todoist-Autorisierung konnte nicht geöffnet werden.",
  "recommend_text": "Chum zu Kjuup, bliib verbunde und bhalt dini Kommunikation im Griff. Bring dini Kanäl zäme, halt Nachrichte i de richtige Projekt und start jede Morge mit ere Zämefassig und dine Ufgabe – alles synchronisiert mit de Apps, wo du scho bruuchsch. Gratis starte:",
  pro_auth_signin_title: 'Willkommen zurück',
  pro_auth_signin_sub: 'Melden Sie sich mit Ihrer geschäftlichen E-Mail-Adresse an.',
  pro_auth_email_or_username: 'E-Mail oder Benutzername',
  pro_auth_email_placeholder: 'name@firma.de',
  pro_auth_forgot_password: 'Passwort vergessen?',
  pro_auth_create_account: 'Konto erstellen',
  pro_auth_show_password: 'Passwort anzeigen',
  pro_auth_hide_password: 'Passwort verbergen',
  pro_auth_register_sub: 'Wir senden Ihnen einen Link, um Ihre E-Mail-Adresse zu bestätigen.',
  pro_auth_register_plus_sub: 'Wählen Sie einen Benutzernamen und ein Passwort. Danach legen Sie Ihre Sicherheits-PIN fest.',
  pro_auth_check_credentials: 'Prüfen Sie Ihre E-Mail-Adresse und Ihr Passwort',
  pro_news_export_pdf: 'Als PDF exportieren',
  pro_news_pdf_failed: 'Das PDF konnte nicht erstellt werden.',
  pro_news_pdf_attachments: 'Anhänge',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link, mit dem Sie Ihr Passwort zurücksetzen können.',
  pro_auth_send_link: 'Link senden',
  pro_auth_plus_reset: 'Mit PIN zurücksetzen',
  pro_auth_show_pin: 'PIN anzeigen',
  pro_auth_hide_pin: 'PIN verbergen',
  v2_auth_plus_only: 'Nur Kjuup+',
  "room_action_media": "Dateie",
  "room_tab_overview": "Übersicht",
  "room_tab_history": "Verlauf",
  "chat_info_media": "Dateie",
  "messages": "Nochrichte",
  pro_todo_project_required: "Bitte wähl es Projekt us",
  pro_todo_choose_project: "Für weles Projekt isch d Ufgab?",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-Kontäkt",
  combined_tab_teams: "Teams-Kontäkt",
  combined_bridge_failed: "D Teams-Kopie het nöd chönne erstellt wärde.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- und Teams-Kontäkt: Es wird e neui Gruppe erstellt, wo au i Microsoft Teams erschiint.",
  teams_new_chat_title: "Neue Teams-Chat",
  teams_new_chat_topic: "Gruppename (optional)",
  teams_new_chat_start: "Chat starte",
  teams_new_chat_creating: "Chat wird erstellt…",
  teams_new_chat_forbidden: "Microsoft Teams erlaubt dä Chat nöd (z. B. e Person usserhalb vo dinere Organisation oder e Richtlinie vo dinere IT).",
  teams_new_chat_too_many: "Z vill Persone für ei Chat.",
  teams_new_chat_type_hint: "Tipp en Name, zum i dinere Organisation sueche.",
  teams_new_chat_directory_forbidden: "Dini Organisation erlaubt d Suechi im Verzeichnis nöd. Es wärde nur Persone us dine Teams-Chats zeigt.",
  teams_new_chat_account: "Konto",
};
